'use strict';

Number.isFinite = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};

(function () {
    if(typeof window.CustomEvent === "function") {return false;}

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

var util = angular.module('gymsystem.util', ['gymsystem.formatter', 'gymsystem.banks']);

// DOMPurify config: keep the markup the editor legitimately produces — <iframe>
// video embeds (insertVideo) and inline styles — while still stripping
// scripts/event-handlers/javascript: URLs. Default DOMPurify drops <iframe>,
// which would silently delete embedded videos on save/render.
var ZOEZI_PURIFY_CONFIG = { ADD_TAGS: ['iframe'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'] };

// Decorate $sanitize with DOMPurify so ng-bind-html, $sce and textAngular's
// taSanitize all strip stored XSS from rich-text content.
if (window.DOMPurify) {
    // Force rel="noopener noreferrer" on target="_blank" links (tabnabbing).
    window.DOMPurify.addHook('afterSanitizeAttributes', function(node) {
        if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
            // Merge into existing rel (e.g. nofollow/ugc) instead of overwriting.
            var rel = (node.getAttribute('rel') || '').split(/\s+/);
            if (rel.indexOf('noopener') === -1) { rel.push('noopener'); }
            if (rel.indexOf('noreferrer') === -1) { rel.push('noreferrer'); }
            node.setAttribute('rel', rel.filter(Boolean).join(' '));
        }
    });
}

util.config(['$provide', function($provide) {
    $provide.decorator('$sanitize', ['$delegate', function($delegate) {
        return function(html) {
            if (window.DOMPurify) {
                return window.DOMPurify.sanitize(html == null ? '' : String(html), ZOEZI_PURIFY_CONFIG);
            }
            return $delegate(html);
        };
    }]);
}]);

// Sanitize pastes into the textAngular editor. The browser inserts raw clipboard
// HTML into the live contentEditable, so <img onerror>/<svg onload> fire before
// $sanitize runs. Intercept in the capture phase and insert cleaned HTML instead.
util.run([function() {
    document.addEventListener('paste', function(e) {
        if (!window.DOMPurify) { return; }

        // Resolve the element the paste lands in (target may be a text node).
        var node = e.target;
        if (!node || typeof node.closest !== 'function') { node = document.activeElement; }
        if (!node || typeof node.closest !== 'function') { return; }

        // Act on a textAngular editor: the WYSIWYG contentEditable or the
        // "Toggle HTML" source <textarea>. Both feed the same model, and the
        // (hidden) WYSIWYG renders it live, so a paste into either must be
        // sanitized first or <img onerror>/<svg onload> fire on render.
        var editable = node.closest('[contenteditable="true"]');
        var htmlSource = node.closest('textarea[id^="taHtmlElement"]');
        var target = editable || htmlSource;
        if (!target) { return; }
        var isTextAngular = (target.id && (target.id.indexOf('taTextElement') === 0 || target.id.indexOf('taHtmlElement') === 0)) ||
            !!node.closest('.ta-root, .ta-editor, .ui-editor');
        if (!isTextAngular) { return; }

        var clipboard = e.clipboardData || window.clipboardData;
        if (!clipboard) { return; }

        var html = '';
        try { html = clipboard.getData('text/html'); } catch (ex) { html = ''; }
        var text = '';
        try { text = clipboard.getData('text/plain') || clipboard.getData('Text') || ''; } catch (ex2) { text = ''; }

        // Block the native paste and textAngular's own paste handler; we own the
        // (sanitized) insert. stopImmediatePropagation works because we capture
        // on document, before the editor-level handlers run.
        e.preventDefault();
        e.stopImmediatePropagation();

        if (htmlSource) {
            // Source mode edits raw HTML as text: sanitize the pasted source and
            // insert it as text so the shared model never holds dangerous HTML.
            var cleanSource = window.DOMPurify.sanitize(text || html, ZOEZI_PURIFY_CONFIG);
            try {
                document.execCommand('insertText', false, cleanSource);
            } catch (exS) {
                // Insert at the caret/selection rather than appending to the end.
                var start = htmlSource.selectionStart, end = htmlSource.selectionEnd;
                if (typeof htmlSource.setRangeText === 'function' && start != null) {
                    htmlSource.setRangeText(cleanSource, start, end, 'end');
                } else {
                    htmlSource.value = htmlSource.value + cleanSource;
                }
            }
        } else {
            var clean;
            if (html) {
                clean = window.DOMPurify.sanitize(html, ZOEZI_PURIFY_CONFIG);
            } else {
                var holder = document.createElement('div');
                holder.textContent = text; // HTML-escape plain text before insertHTML
                clean = holder.innerHTML;
            }
            try {
                document.execCommand('insertHTML', false, clean);
            } catch (ex3) {
                editable.innerHTML = editable.innerHTML + clean;
            }
        }

        // Let textAngular re-read its ng-model from the now-clean DOM. Its
        // textarea binding commits on "change" (not "input"), so fire both.
        ['input', 'change'].forEach(function(type) {
            var evt;
            try {
                evt = new Event(type, { bubbles: true });
            } catch (ex4) {
                evt = document.createEvent('Event');
                evt.initEvent(type, true, true);
            }
            target.dispatchEvent(evt);
        });
    }, true);
}]);

util.factory('genders', ['util', function(util) {
    var genderList = [{name: 'Female', id: 'female'}, {name: 'Male', id: 'male'}, {name: 'GENDER_OTHER', id: 'other'}];

    var genders = {};

    genders.getList = function() {
        return genderList;
    };

    genders.getGender = function(personalCodeNumber) {
        if (!util.isValidPersonalCode(personalCodeNumber)) { return ''; }
        return ((parseInt(personalCodeNumber[10]) % 2) == 0) ? 'female' : 'male';
    };

    return genders;
}]);

// blank factory to inject to controller
util.factory('options', [function () {
    return {};
}]);

util.factory('alertProvider', ['$rootScope', '$filter', 'util', '$modal', function ($rootScope, $filter, util, $modal) {
    var alertProvider = {};

    alertProvider.show = function(type, message, translated, timeoutclose) {
        if (!timeoutclose) {timeoutclose = 5000;}
        var pclass = util.isInIframe() || util.isSmallScreen() ? 'toast-almost-top-full-width' : 'toast-bottom-left-skip-nav';
        var options = { closeButton: true, positionClass: pclass, timeOut: timeoutclose };
        if (!translated) {
            message = $filter('translate')(message);
        }

        if ($rootScope.parentHandlesToast) {
            $rootScope.handleToast({type, message, timeOut: timeoutclose});
            return;
        }

        toastr[type](message, null, options);
    };

    alertProvider.modal = function(title, content, option) {
        option = option || {};
        option.title = title;
        option.content = content;
        $modal.open({
            templateUrl: 'views/infomodal.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return option;
                }
            }
        });
    };

    return alertProvider;
}]);


util.factory('jsoncoder', ['Link', function (Link) {
    // coder post2
    function decode(data, deep) {
        deep = deep || 99;
        if(deep < 1) {
            console.warn('Recursion is detected');
            return data;
        }
        if(data == null) {return null;}
        if(typeof(data) !== 'object') {
            return data;
        }
        if(window.Blob && data instanceof window.Blob) {
            return data;
        }

        if(data.$datetime) {
            var d = data.$datetime.match(/^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/);
            return new Date(d[1], d[2]-1, d[3], d[4], d[5], d[6]);
        }

        if(data.$date) {
            var d = data.$date.match(/^(\d{4})-(\d\d)-(\d\d)$/);
            return new Date(d[1], d[2]-1, d[3]);
        }

        if(data.$decimal) {
            return parseFloat(data.$decimal);
        }

        if(data.$link) {
            return new Link(data);
        }

        if(Array.isArray(data)) {
            var result = new Array(data.length);
            for(var i=0;i<data.length;i++) {
                result[i] = decode(data[i], deep-1);
            }
            return result;
        }

        var result = {};
        for(var key in data) {
            result[key] = decode(data[key], deep-1);
        }
        return result;
    }

    function d2(x) {
        return x<10?'0'+x:x;
    }

    function encode(data, deep) {
        deep = deep || 99;
        if(deep < 1) {
            console.warn('Recursion is detected');
            return data;
        }

        if(data == null) {return null;}
        if(typeof(data) !== 'object') {
            return data;
        }

        if(data instanceof Date) {
            return {
                $datetime: data.getFullYear() + '-' + d2(data.getMonth()+1) + '-' + d2(data.getDate()) + ' ' +
                    d2(data.getHours()) + ':' + d2(data.getMinutes()) + ':' + d2(data.getSeconds())
            };
        }

        if(data instanceof Link) {
            return {
                $link: data.type,
                id: data.id
            };
        }

        if(Array.isArray(data)) {
            var result = new Array(data.length);
            for(var i=0;i<data.length;i++) {
                result[i] = encode(data[i], deep-1);
            }
            return result;
        }

        var result = {};
        for(var key in data) {
            result[key] = encode(data[key], deep-1);
        }
        return result;
    }

    return {
        decode: decode,
        encode: encode
    };
}]);


util.factory('server', ['$rootScope', '$filter', '$http', '$q', 'alertProvider', 'jsoncoder', 'live', 'util', function ($rootScope, $filter, $http, $q, alertProvider, jsoncoder, live, util) {
    var server = {};

    var promiseBlocks = {};
    var promiseIndex = 0;

    $q.promise = function(fn) {
        var d = $q.defer();
        var r = fn(d.resolve, d.reject);
        if(r && r.then) {r.then(d.resolve, d.reject);}

        for(var i in promiseBlocks) {
            promiseBlocks[i].push(d.promise);
        }
        return d.promise;
    };

    $q.waitBlock = function(fn) {
        var promises = [];
        var index = promiseIndex++;
        promiseBlocks[index] = promises;
        fn();
        delete promiseBlocks[index];
        return $q.all(promises);
    };

    $q.allSettled = function(list) {
        return $q.promise(function(resolve) {
            var left = 0;
            list.forEach(function(p) {
                left++;
                p.finally(function() {
                    left--;
                    if(!left) {resolve();}
                });
            });
            if(!left) {resolve();}
        });
    };

    server.getCookie = function(name) {  // $cookies doesn't work after login
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {return parts.pop().split(";").shift();}
    };

    var getMessage = function(msg, itemTitle, lowercase) {
        msg = $filter('translate')(msg);
        if (msg.indexOf('{0}') != -1) {
            itemTitle = $filter('translate')(itemTitle);
            msg = msg.format(lowercase ? itemTitle.toLowerCase() : itemTitle);
        }
        return msg;
    };

    var getQuery = function(args) {
        var query = '';
        args = angular.copy(args) || {};
        if (!server.cookieSupport && server.session) {
            args.session = server.session;
        }

        if (args) {
            var pairs = [];
            angular.forEach(args, function(value, key) {
                var pair = key + "=" + (value == undefined ? '' : encodeURIComponent(value));
                pairs.push(pair);
            });
            if (pairs.length) {
                query = '?' + pairs.join('&');
            }
        }

        return query;
    };

    function channel2Response(key, scope) {
        return $q.promise(function(resolve, reject) {
            var stopChannel2 = live.channel2(scope, key, function(response) {
                if(response.status === 'done') {
                    stopChannel2();
                    $rootScope.$evalAsync(function() {
                        resolve(response.result);
                    });
                } else if(response.status === 'error') {
                    stopChannel2();
                    $rootScope.$evalAsync(function() {
                        reject(response.result);
                    });
                }
            });
        });
    }

    server.post = function(url, data, args, messageSuccess, messageFail, itemTitle, config) {
        return $q.promise(function(iresolve) {
            var filename;
            function resolve(data) {
                if (messageSuccess) {
                    alertProvider.show('success', getMessage(messageSuccess, itemTitle), true);
                }
                iresolve({success: true, data: data, filename: filename});
            }
            function reject(data) {
                if (messageFail) {
                    // Check if there is a better error message sent from the server
                    if (data?.message && data.message != 'Invalid input') {
                        alertProvider.show('error', data.message);
                    } else {
                        alertProvider.show('error', getMessage(messageFail, itemTitle, true), true);
                    }
                }
                iresolve({success: false, data: data});
            }

            config = {...config, headers: { 'Content-Type': 'application/json' } }
            url += getQuery(args);
            $http.post(url, data, config).success(function (data, status, headers) {
                if(data && data.$channel2) {
                    channel2Response(data.$channel2).then(resolve, reject);
                } else {
                    if(data instanceof Blob) {
                        var cd = headers('content-disposition');
                        cd = decodeURIComponent(cd).split('filename=');
                        if(cd[1]) {filename = cd[1];}
                    }
                    resolve(data);
                }
            }).error(reject);
        });
    };

    function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = window.unescape(dataURI.split(',')[1]);
        }

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type:mimeString});
    }

    server.postFile = function(url, file, messageSuccess, messageFail, itemTitle, formData) {
        var deferred = $q.defer();

        var fd;
        if (file) {
            fd = new FormData();
            if(typeof(file) === 'string' && file.slice(0, 10) === 'data:image') {
                var blob = dataURItoBlob(file);
                fd.append("file", blob);
            } else {
                if (file.length) {
                    for (var i=0; i < file.length; ++i) {
                        fd.append('file-' + i, file[i]);
                    }
                } else {
                    fd.append('file', file);
                }
            }

            if (formData) {
                _.keys(formData).forEach(function(k) {
                    var value = formData[k];
                    if (_.isObject(value)) {
                        value = JSON.stringify(value);
                    }
                    fd.append(k, value);
                });
            }
        }

        url += getQuery();

        $http.post(url, fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function(data) {
            if (messageSuccess) {
                alertProvider.show('success', getMessage(messageSuccess, itemTitle), true);
            }
            deferred.resolve({success: true, data: data});
        }).error(function(data) {
            if (messageFail) {
                alertProvider.show('error', getMessage(messageFail, itemTitle, true), true);
            }
            deferred.resolve({success: false, data: data});
        });

        return deferred.promise;
    };

    server.get = function(url, args, cancelPromise, config) {
        var deferred = $q.defer();

        url += getQuery(args);
        var options = {};
        if (cancelPromise) {
            options.timeout = cancelPromise.promise;
        }
        angular.extend(options, config);
        $http.get(url, options).success(function (data) {
            deferred.resolve(jsoncoder.decode(data));
        }).error(function() {
            deferred.reject();
        });
        return deferred.promise;
    };

    server.setSession = function(session) {
        server.session = session;
        $rootScope.expoPostMessage('session', session);
    };

    // Check if user accept cookies
    document.cookie = "acceptcookie";
    server.cookieSupport = document.cookie.indexOf("acceptcookie") != -1;

    server.post2 = function(url, data, option) {
        return $q.promise(function(iresolve, ireject) {
            option = option || {};  // for future features

            if(!server.cookieSupport && server.session && !option.session) {
                option.session = server.session;
            }

            if(option.session) {
                url += (url.indexOf('?') > 0)?'&':'?';
                url += 'session=' + option.session;
            }

            function resolve(data) {
                if(option.successAlert) {
                    alertProvider.show('success', option.successAlert);
                }
                iresolve(data);
            }

            function reject(httpResponse) {
                try {
                    httpResponse.data = jsoncoder.decode(JSON.parse(httpResponse.data));
                } catch (e) {}
                if(option.errorAlert) {
                    var message = httpResponse && httpResponse.data && httpResponse.data.message;
                    if(message && message !== 'Invalid input') {
                        alertProvider.show('error', message);
                    } else {
                        alertProvider.show('error', option.errorAlert);
                    }
                }
                ireject(httpResponse);
            }

            var raw = JSON.stringify(jsoncoder.encode(data));
            var postConfig = {
                timeout: option.timeout,
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: {
                    'Content-Type': 'application/json',
                    'encoder': 'post2'
                }
            };
            if(option.download) {postConfig.responseType = 'blob';}
            $http.post(url, raw, postConfig).then(function(httpResponse) {
                if(option.download && httpResponse.data instanceof Blob) {
                    var cd = httpResponse.headers('content-disposition');
                    cd = decodeURIComponent(cd).split('filename=');
                    var filename;
                    if(cd[1]) {filename = cd[1];}
                    util.download(filename || 'file', null, null, httpResponse.data);
                    return resolve(httpResponse);
                }

                var data;
                try {
                    data = jsoncoder.decode(JSON.parse(httpResponse.data));
                } catch (e) {
                    return reject({data: null});
                }
                if(data && data.$channel2) {
                    channel2Response(data.$channel2, option.scope).then(resolve, function(data) {
                        reject({data: data});
                    });
                } else {
                    resolve(data);
                }
            }, reject);
        });
    };

    return server;
}]);

util.factory('util', ['$q', '$timeout', 'serverDownloader', 'live', '$modal', '$translate', 'pubsub', '$rootScope', '$filter', 'taOptions', '$window', 'taRegisterTool', 'taTranslations', 'taTools', '$injector', '$modalStack', function($q, $timeout, serverDownloader, live, $modal, $translate, pubsub, $rootScope, $filter, taOptions, $window, taRegisterTool, taTranslations, taTools, $injector, $modalStack) {
    var util = {};

    util.isSmallScreen = function() {
        return $(window).width() <= 768;
    };

    util.t = $filter('translate');

    // Sending to inkasso fails the invoice attempt and adds a later inkasso attempt, which is never
    // marked as paid. The latest attempt then holds neither the sent nor the paid date.
    var hasInkassoAttempt = function(payment) {
        return !!_.findWhere(payment.attempts, {status: 'inkasso'});
    };

    util.getInkassoSentAttempt = function(payment) {
        if (!hasInkassoAttempt(payment)) { return; }
        return _.find(payment.attempts, function(a) { return a.invoice_id; });
    };

    util.getInkassoPaidAttempt = function(payment) {
        if (payment.status !== 'paid' || !hasInkassoAttempt(payment)) { return; }
        return _.last(_.where(payment.attempts, {status: 'paid'}));
    };

    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
    util.getMobileOperatingSystem = function() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    };

    util.calculateMinMaxTime = function(times, minTime, maxTime, allowOverMidnight) {
        var res = {minTime: minTime != undefined ? minTime : undefined, maxTime: maxTime != undefined ? maxTime : undefined};

        var setMinMax = function(time) {
            if (!time.start.isSameDateAs(time.end) && time.end.getHours() > 3) {
                res.minTime = 0;
                res.maxTime = 24;
            } else {
                res.minTime = Math.min(res.minTime == undefined ? 24 : res.minTime, time.start.getHours() - 1);
                if (time.start.getHours() > time.end.getHours()) {
                    res.maxTime = Math.max(res.maxTime == undefined ? 0 : res.maxTime, 24 + time.end.getHours() + 1 + (time.end.getMinutes() > 30 ? 1 : 0));
                } else if (time.end.getHours() == 0) {
                    res.maxTime = Math.max(res.maxTime == undefined ? 0 : res.maxTime, 24 + 1);
                } else {
                    res.maxTime = Math.max(res.maxTime == undefined ? 0 : res.maxTime, time.end.getHours() + 1 + (time.end.getMinutes() > 30 ? 1 : 0));
                }

                if (!allowOverMidnight) {
                    res.minTime = Math.max(0, res.minTime == undefined ? 24 : res.minTime);
                    res.maxTime = Math.min(24, res.maxTime == undefined ? 0 : res.maxTime);
                }
            }
        };

        angular.forEach(times, function(time) {
            if (angular.isArray(time)) {
                res = util.calculateMinMaxTime(time, res.minTime, res.maxTime, allowOverMidnight);
            } else {
                if(time.start && time.end) {setMinMax(time);}
            }
        });
        return res;
    };

    util.normalizePersonalCodeNumber = function(x) {
        if (!x) {
            return null;
        }
        x = x.replace(/-/g, '');
        x = x.replace(/\s/g, '');
        if (x.length == 10) {
            if (Number(x[2]) < 2) {
                //Assume the person is born in the 2000's. If the date is greater than
                //current date, subtract 100 years from PCN. This gives us the correct 1900's PCN.
                var xDate = Date.newFull("20"+x.substring(0,2) + "-" + Number(x.substring(2,4) - 1) + "-" + x.substring(4,6));
                //if the PCN date is not possible in the 2000's, convert to 1900's.
                x = (xDate.isFutureDate() ? x = "19" + x : x = "20" + x);

            }
        }

        return x;
    };

    util.isValidPersonalCode = function(x) {
        x = util.normalizePersonalCodeNumber(x);
        if (!x || x.length != 12 || isNaN(x)) {
            return false;
        }

        var year = x.substring(0, 4);
        var month = x.substring(4, 6);
        var day = x.substring(6, 8);
        if (year < 1900 || year > 2099 || month > 12 || day > 31) {
            return false;
        }

        var sum = 0;
        for (var i=2; i < 11; ++i) {
            var factor = (i%2) == 0 ? 2 : 1;
            var d = Number(x[i]);
            var c = d * factor;
            sum += Math.floor(c / 10) + (c % 10);
        }

        var controlCode = 10 - (sum % 10);
        if (controlCode == 10) {
            controlCode = 0;
        }

        return Number(x[9+2]) == controlCode;
    };

    util.normalizeCorporateIdentity = function(x) {
        if (!x) {
            return null;
        }
        x = x.replace('-', '');
        x = x.replace(' ', '');
        return x;
    };

    util.isValidCorporateIdentity = function(x) {
        if (util.isValidPersonalCode(x)) {
            return true;
        }

        x = util.normalizeCorporateIdentity(x);
        if (!x || x.length != 10 || isNaN(x)) {
            return false;
        }

        if (Number(x.substring(2, 3)) < 2) {
            return false;
        }

        var sum = 0;
        for (var i=0; i < 9; ++i) {
            var factor = (i%2) == 0 ? 2 : 1;
            var d = Number(x[i]);
            var c = d * factor;
            sum += Math.floor(c / 10) + (c % 10);
        }

        var controlCode = 10 - (sum % 10);
        if (controlCode == 10) {
            controlCode = 0;
        }

        return Number(x[9]) == controlCode;
    };

    util.isInIframe = function() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };

    util.waitForVisible = function(element) {
        var deferred = $q.defer();
        var delay = 50;

        var check = function() {
            if ($(element).filter(':visible').length) {
                deferred.resolve();
            } else {
                $timeout(check, delay);
                if(delay < 1000) {delay += 10;}
            }
        };

        check();

        return deferred.promise;
    };

    util.normalizeDecimal = function(x) {
        if (x) {
            x = String(x).replace(',', '.');
            x = String(Number(x)).replace('.', ',');
        }
        return x;
    };

    util.normalizeRelativeTime = function(x) {
        if (x) {
            return {
                value: x.value,
                timeunit: _.isObject(x.timeunit) ? x.timeunit.id : x.timeunit,
                relative: _.isObject(x.relative) ? x.relative.id : x.relative
            };
        }

        return x;
    };

    util.timeunits = [{id: 'day', name: 'Days'}, {id: 'hour', name: 'Hours'}, {id: 'week', name: 'Weeks'}, {id: 'month', name: 'Months'}];
    util.relative = [{id: 'beforestart', name: 'Before start'}, {id: 'afterstart', name: 'After start'}];

    util.getHoursFromRelativeTime = function(value, timeunit) {
        // Converts time to hours (approximately since a month is not always 30 days)
        if (timeunit == 'day') {
            return value * 24;
        } else if (timeunit == 'hour') {
            return value;
        } else if (timeunit == 'week') {
            return value * 7 * 24;
        } else if (timeunit == 'month') {
            return value * 30 * 24;
        }
    };

    util.download = function(filename, data, type, blob) {
        blob = blob || new Blob([data], { type: type || 'application/octet-stream' });

        if(navigator.msSaveBlob) { // IE10+
            return navigator.msSaveBlob(blob, filename);
        }

        if(serverDownloader.isSafari()) {
            return serverDownloader.download({
                blob: blob,
                filename: filename
            });
        }

        // file-saver
        window.saveAs(blob, filename);

        /*
        var URL = window.URL || window.webkitURL;
        var downloadUrl = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 1000); // cleanup
        */
    };

    util.parseDecimal = function(value) {
        if (value === null || value === undefined) {
            return NaN;
        }
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            var normalized = value.replace(/\s/g, '').replace(/\u00A0/g, '').replace(/'/g, '');
            if (normalized === '') {
                return 0;
            }
            var lastDot = normalized.lastIndexOf('.');
            var lastComma = normalized.lastIndexOf(',');
            var decimalSeparator = lastDot > lastComma ? '.' : (lastComma > -1 ? ',' : null);

            if (decimalSeparator === ',') {
                normalized = normalized.replace(/\./g, '');
                normalized = normalized.replace(',', '.');
            } else if (decimalSeparator === '.') {
                normalized = normalized.replace(/,/g, '');
            } else {
                normalized = normalized.replace(',', '.');
            }

            var parsed = Number(normalized);
            return isNaN(parsed) ? NaN : parsed;
        }
        var coerced = Number(value);
        return isNaN(coerced) ? NaN : coerced;
    };

    util.sanitizeHtml = function(html) {
        // $sanitize is DOMPurify-decorated; strips XSS, never returns raw on failure.
        return html == null ? html : $injector.get('$sanitize')(String(html));
    };

    util.getValueForField = function(field) {
        var value;
        if (field.getValue) {
            value = field.getValue(field);
        } else {
            if (field.useId) {
                if (Array.isArray(field.value)) {
                    value = _.pluck(field.value, 'id');
                } else {
                    value = field.value && field.value.id;
                }
            } else if (field.type == 'date' || field.type == 'month' || field.type == 'week') {
                if (!(field.value instanceof Date)) {
                    field.value = Date.newFull(field.value);
                }
                value = field.value && field.value.yyyymmdd();
            } else if (field.type == 'datetime') {
                if (!(field.value instanceof Date)) {
                    field.value = Date.newFull(field.value);
                }
                value = field.value && field.value.dateTime();
            } else if (field.type == 'dateinterval') {
                value = field.value && {from: field.value.from.yyyymmdd(), to: field.value.to.yyyymmdd() };
            } else if (field.type == 'time') {
                value = field.value && field.value.hhmm();
            } else if (field.type == 'paymentmethod' || field.type == 'customer') {
                value = field.value && field.value.id;
            } else if (field.type == 'relativetime') {
                value = field.value && {value: field.value.value, timeunit: field.value.timeunit.id, relative: field.value.relative ? field.value.relative.id: null};
            } else if (field.type == 'checkbox') {
                value = field.value ? true : false;
            } else if (field.type == 'textarea' && field.emailList) {
                value = field.value && field.value.split(/[\s,\n]+/).filter(function(e) { return !!e; });
            } else if (field.type == 'price') {
                var parsedPrice = util.parseDecimal(field.value);
                value = isNaN(parsedPrice) ? field.value : parsedPrice;
            } else if (field.type == 'legal_entity') {
                value = $rootScope.selectedSite && $rootScope.selectedSite.legal_entity_id;
            } else {
                value = field.value;
            }
        }
        // Sanitize rich-text here, in the shared accessor every submit loop calls,
        // so no loop can forget it.
        if (field.type === 'htmleditor') {
            value = util.sanitizeHtml(value);
        }
        return value;
    };

    util.getSubmitItem = function(fields, id) {
        var item = {};
        if (id !== undefined) {
            item.id = id;
        }
        for (var i = 0; i < fields.length; ++i) {
            var field = fields[i];
            if ((field.type == 'label' || field.readonly || !field.type || !field.name || field.type == 'button') && !field.doSubmit) {
                continue;
            }
            if (!field.includeInvisible && field.visible && !field.visible(field)) {
                continue;
            }
            var value = util.getValueForField(field);

            if (field.splitted_name && field.splitted_name.length > 0) {
                var sn = field.splitted_name;
                if (sn.length == 2) {
                    if (!item[sn[0]]) {
                        item[sn[0]] = {};
                    }
                    item[sn[0]][sn[1]] = value;
                } else {
                    item[field.name] = value;
                }
            } else if (field.name.indexOf('.') != -1) {
                var parts = field.name.split('.');
                if (!item[parts[0]]) {
                    item[parts[0]] = {};
                }
                item[parts[0]][parts[1]] = value;
            } else {
                item[field.name] = value;
            }

            if (field.type == 'password') {
                delete field.value;
            }
        }

        return item;
    };

    util.getDescendantProp = function (obj, desc) {
        var arr = Array.isArray(desc) ? angular.copy(desc) : desc.split(".");
        while(arr.length && (obj = obj[arr.shift()])) {}
        return obj;
    };

    util.setValues = function(fields, item, option) {
        option = option || {};

        fields.forEach(function(field) {
            if (option.dontSetInvisible && field.visible && !field.visible(field)) {
                return;
            }
            if (!field.name) {
                return;
            }
            var value = util.getDescendantProp(item, field.splitted_name || field.name);
            if (field.setValue) {
                field.value = field.setValue(field, value);
            } else {
                if (field.useId && field.getValuesFunc) {
                    field.value = _.findWhere(field.getValuesFunc(), {id: value});
                } else if (field.useId && !field.getValuesFunc) {
                    if (field.type == 'select') {
                        if (field.optionsfilter) {
                            field.value = _.findWhere(field.options().filter(field.optionsfilter), {id: value});
                        } else {
                            if (_.isArray(value) && value.length) {
                                value = value[0];
                            }
                            field.value = _.findWhere(field.options(), {id: _.isObject(value) ? value.id : value});
                        }
                    } else if (field.type == 'multiselect') {
                        if (field.optionsfilter) {
                            field.value = field.options().filter(field.optionsfilter).filter(function(x) { return value.indexOf(x.id) != -1; });
                        } else {
                            var options = field.options();
                            if (angular.isString(value)) {
                                field.value = [];
                                var a = _.findWhere(options, {id: value});
                                if (a) {
                                    field.value.push(a);
                                }
                            } else {
                                field.value = value ? value.map(function(id) {
                                    return _.findWhere(options, {id: _.isObject(id) ? id.id : id});
                                }).filter(Boolean) : [];
                            }
                        }
                    } else if (field.type == 'customer') {
                        field.value = $rootScope.getMember(value);
                    } else if (field.type == 'customers') {
                        field.value = value ? value.map(function(id) {
                            return $rootScope.getMember(id);
                        }).filter(Boolean) : [];
                    } else if (field.type == 'group') {
                        field.value = $rootScope.getGroup(value);
                    } else if (field.type == 'groups') {
                        field.value = value ? value.map(function(id) {
                            return $rootScope.getGroup(id);
                        }).filter(Boolean) : [];
                    } else if (field.type == 'products') {
                        var options = $rootScope.trainingcardtypes;
                        field.value = value ? value.map(function(id) {
                            return _.findWhere(options, {id: _.isObject(id) ? id.id : id});
                        }).filter(Boolean) : [];
                    } else if (field.type == 'supplier') {
                        field.value = $rootScope.getMember(value);
                    }
                } else if (field.type == 'date' || field.type == 'month' || field.type == 'week' || field.type == 'datetime') {
                    if (typeof value == 'string') {
                        value = Date.newFull(value);
                    }
                    field.value = value;
                } else if(field.type == 'time') {
                    if (typeof value == 'string') {
                        value = Date.newFull(new Date().yyyymmdd() + ' ' + value);
                    }
                    field.value = value;
                } else if (field.type == 'price' || field.type == 'percent') {
                    field.value = util.normalizeDecimal(value);
                } else if (field.type == 'number') {
                    field.value = (value === null || value === undefined) ? value : Number(value);
                } else if (field.type == 'checkbox') {
                    field.value = !!value;
                } else if (field.type == 'relativetime') {
                    value = util.normalizeRelativeTime(value);
                    if (value) {
                        value.timeunit = _.findWhere(field.timeunits(), {id: value.timeunit});
                        value.relative = field.relative ? _.findWhere(field.relative(), {id: value.relative}) : null;
                    }
                    field.value = value;
                } else if (field.type == 'customertable') {
                    field.value = angular.copy(value);
                } else if (field.type == 'systemtag') {
                    var options = $rootScope.systemtags.concat(value || []);
                    field.value = value ? value.map(function(id) {
                        return _.findWhere(options, {id: _.isObject(id) ? id.id : id});
                    }).filter(Boolean) : [];
                } else {
                    field.value = value;
                }
            }

            if (option.callChange && field.change) {
                field.change();
            }
        });
    };

    util.valueChanged = function(field, item) {
        if ((field.skipChangedCheck || field.type == 'label' || field.type == 'button' || field.type == 'alert' || !field.name) && !field.doSubmit) {
            return false;
        }

        var visible = !field.visible || field.visible && field.visible(field);
        if (visible) {
            if (field.changed) {
                return field.changed(field);
            }
        } else if(field.invisibleValue === undefined) {return;}

        var value;
        if (!visible) {
            value = field.invisibleValue;
        } else if (field.getValue) {
            value = field.getValue(field);
        } else if (field.useId) {
            if (Array.isArray(field.value)) {
                value = _.pluck(field.value, 'id');
            } else {
                value = field.value && field.value.id;
            }
        } else {
            value = field.value;
        }
        var o = util.getDescendantProp(item, field.splitted_name || field.name);

        if (field.type == 'date') {
            return !Date.dateEquals(value, o);
        } else if (field.type == 'time') {
            return !Date.timeEquals(value, o);
        } else if (field.type == 'password') {
            return (value != o) && (value || o);
        } else if (field.type == 'personalCodeNumber') {
            var normalized = util.normalizePersonalCodeNumber(value);
            return (normalized != o) && (normalized || o);
        } else if (field.type == 'corporateIdentity') {
            var normalized = util.normalizeCorporateIdentity(value);
            var normalizedO = util.normalizeCorporateIdentity(o);
            return (normalized != normalizedO) && (normalized || normalizedO);
        } else if (field.type == 'bankgiroNumber') {
            var normalized = $rootScope.normalizeBankgiroNumber(value);
            return (normalized != o) && (normalized || o);
        } else if (field.type == 'paymentmethod' && !field.useId) {
            return value != o && value.id != o;
        } else if (field.type == 'relativetime') {
            return !angular.equals(util.normalizeRelativeTime(o), util.normalizeRelativeTime(value));
        } else if (field.type == 'price' || field.type == 'percent') {
            o = util.normalizeDecimal(o);
            var normalized = util.normalizeDecimal(value);
            return (normalized != o) && (normalized || o);
        } else if (field.type == 'customertable') {
            if(!value || !o) {return value != o;}
            if(value.length !== o.length) {return true;}
            return !util.arraysEqual(value, o);
        } else if (field.type == 'multiselect' && field.useId) {
            if (Array.isArray(o)) {
                o = o.map(function(x) { return _.isObject(x) ? x.id : x; });
            }
            if(o == null && (!value || !value.length)) {return false;}
            if(!value || !o) {return value != o;}
            if(value.length !== o.length) {return true;}
            if(field.version === 2) {
                for(var i=0; i<value.length;i++) {
                    if(value[i] !== o[i]) {return true;}
                }
                return false;
            }
            return !util.arraysEqual(value, o);
        } else if (field.type == 'systemtag') {
            if(!value || !o) {return value != o;}
            if (value.length !== o.length) {return true;}
            if (_.intersection(_.pluck(value, 'id'), _.pluck(o, 'id')).length !== value.length) {return true;}
            return false;
        } else {
            if (field.useId && Array.isArray(value)) {
                if (o) {
                    o = o.map(function(v) { return _.isObject(v) ? v.id : v; });
                }
                return !util.arraysEqual(value, o);
            } else if (Array.isArray(value)) {
                return !angular.equals(value, o);
            }

            if (field.useId && _.isObject(o)) {
                o = o.id;
            }

            return (value != o) && (field.nullIsValue || value || o);
        }
    };

    util.arraysEqual = function(a, b) {
        return angular.equals(angular.copy(a).sort(), b && angular.copy(b).sort());
    };

    util.fieldsValid = function(fields) {
        return !_.find(fields, function(field) {
            if (field.required && (!field.visible || field.visible(field))) {
                return field.value == null || field.value.length == 0;
            }
            return false;
        });
    };

    util.getRandomColor = function() {
        return "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
    };

    util.findScope = function(scope, name) {
        for (var cs = scope.$$childHead; cs; cs = cs.$$nextSibling) {
            if (cs[name]) {
                return cs[name];
            } else {
                var found = util.findScope(cs, name);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };

    util.addQuestions = function(fields, questions, name) {
        if (!_.isArray(fields) || !questions) {
            return;
        }

        name = name==null?'answers':name;
        questions.forEach(function(q) {
            var field = {};
            var id = q.name;
            field.name = name?name + '.' + id:id;
            field.title = q.title || q.name;
            field.type = q.type;
            field.placeholder = q.placeholder;
            field.helpText = q.helpText;
            if (q.hint) {
                field.hint = q.hint;
                field.hintClass = q.hintClass;
            }
            field.required = q.required;
            field.splitted_name = (name || name !== '') ? [name, id] : [id];
            if (q.visible) {
                field.visible = q.visible;
            }
            if (field.type == 'select' || field.type == 'multiselect') {
                var options = q.data;
                if (options) {
                    if (_.isFunction(options)) {
                        options = options();
                    }
                    options = options.map(function(o) {
                        if(typeof(o) === 'string') {return {id: o, name: o};}
                        return o;
                    });
                }
                field.options = function() { return options; };
                field.useId = true;
                field.orderPredicate = 'nosort';
                if (q.version == 2) {
                    field.version = q.version;
                    field.getName = function(d) {
                        return $filter('translate')(d.name);
                    };
                }
            } else if (field.type == 'field') {
                field.option = q.option;
                field.field = q.field;
            } else if (field.type == 'number') {
                field.min = q.min || 0;
                field.max = q.max;
            } else if (field.type == 'infoNumber') {
                field.info = q.info;
                field.min = q.min || 0;
                field.max = q.max;
            } else if (field.type == 'customer' || field.type == 'customers') {
                field.itemTypes = q.itemTypes;
                field.useId = true;
            }
            fields.push(field);
        });
    };

    util.getRealFormName = function(name) {
        var i = name.indexOf('$');
        if (i != -1) {
            name = name.substring(0, i);
        }
        return name;
    };

    util.waitForNewObject = function(id, getObject, type, action) {
        var deferred = $q.defer();

        if (id && id.id) {  // is it object?
            id = id.id;
        }

        var object = getObject(id);
        if (object) {
            deferred.resolve(object);
        } else {
            var unsubscribe = live.subscribe( {
                type: type,
                action: action || 'add',
                callback: function() {
                    $timeout(function() {
                        var object = getObject(id);
                        if (object) {
                            deferred.resolve(object);
                            unsubscribe();
                        }
                    });
                }
            });
        }

        return deferred.promise;
    };

    util.waitFor = function(scope, object) {
        var deferred = $q.defer();

        var isObjectAvailable = function() {
            if (_.isArray(object)) {
                return _.all(object, function(x) { return scope[x]; });
            } else if (_.isFunction(object)) {
                return object();
            } else {
                return scope[object];
            }
        };

        if (isObjectAvailable()) {
            deferred.resolve();
        } else {
            var watchHandle = scope.$watch(isObjectAvailable, function(newValue) {
                if (newValue) {
                    deferred.resolve();
                    watchHandle();
                }
            });
        }

        return deferred.promise;
    };

    util.hexToLuma = function(color) {
        var hex   = color.replace(/#/, '');
        var r     = parseInt(hex.substr(0, 2), 16);
        var g     = parseInt(hex.substr(2, 2), 16);
        var b     = parseInt(hex.substr(4, 2), 16);

        return 0.299 * r + 0.587 * g + 0.114 * b;
    };

    util.getContrastColor = function(color) {
        var d = 0;

        if (util.hexToLuma(color) > 186) {
            d = 0; // bright colors - black font
        } else {
            d = 255; // dark colors - white font
        }

        d = Number(d).toString(16);
        return '#' + d + d + d;
    };

    util.isValidMail = function(mail) {
        // check by RFC
        if(!mail) {return false;}
        if(!mail.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {return false;}
        if (mail.match('[åäöÅÄÖ]')) { return false; }
        return true;
    };

    util.showDataDialog = function(options) {
        var modalInstance;
        const mode = options.mode || (options.item ? (options.item.id ? 'change' : 'copy') : 'add');
        const title = {add: 'Add', change: 'Change', copy: 'Copy'}[mode];
        options.config = _.assign({
            item: options.item,
            initial: options.initial,
            mode,
            title,
            successTitle: options.item ? 'Information saved' : 'Item added',
            failedTitle: options.item ? 'Failed to save information' : 'Failed to add item',
            afterSubmit: function(data) {
                modalInstance.close(data);
            },
            data: options.data || {}
        }, options.config);

        modalInstance = $modal.open({
            templateUrl: 'views/datamodal.html',
            windowClass: options.windowClass,
            controller: ['$scope', '$controller', 'confirm', 'options', function($scope, $controller, confirm, options) {
                if(options.controller) {
                    $controller(options.controller, {$scope: $scope, options: options});
                } else {
                    $scope.config = options.config;
                }

                if (!$scope.config.titleSuffix) {
                    $scope.config.titleSuffix = function() {
                        var dt = options.datatype || $scope.config.datatype;
                        return options.item ? options.item.name : (dt ? $filter('translate')(dt) : '');
                    };
                }

                if ($scope.unsavedCheck) {
                    $scope.unsavedCheck();
                }
                $scope.unsavedCheck = $scope.$on('modal.closing', function(event, reason, closed) {
                    if (!closed && !$modalStack.globalForceClose && options.config.control.valuesChangedOrEntered()) {
                        event.preventDefault();
                        confirm.show('You have unsaved changes. Are you sure you want to close?').then(function() {
                            $scope.unsavedCheck();
                            $scope.$dismiss();
                        });
                    }
                });
            }],
            resolve: {
                options: function() {
                    return options;
                }
            }
        });

        return modalInstance;
    };

    util.setTextAngularOptions = function() {
        // https://github.com/textAngular/textAngular/wiki/textAngularManager-Module
        if (!taTools.insertImageLibrary) {
            taTranslations.insertImageLibrary = 'Insert image from library';
            taRegisterTool('insertImageLibrary', {
                tooltiptext: taTranslations.insertImageLibrary,
                iconclass: 'fa fa-picture-o',
                action: function(){
                    $injector.get('fileManager').chooseFile({
                        'originType': 'mailing',
                        'imageOnly': true,
                        'squareThumbnail': false
                    }).then(function(file) {
                        var editor = $('[id^="taTextElement"');
                        editor.append('<img src="' + document.location.protocol + '//' + $rootScope.getHost() + '/api/utils/file/download?key=' + file.key + '" />');
                        setTimeout(function() {
                            editor.focus();
                        }, 100);
                    });
                },
                onElementSelect: {
                    element: 'img'
                }
            });
        }

        taTools.insertImage.iconclass = 'cticon-image-link';
        taOptions.toolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'],
            ['bold', 'italics', 'underline', 'ul', 'ol'],
            ['justifyLeft', 'justifyCenter', 'justifyRight'],
            ['html', 'insertImage','insertImageLibrary', 'insertLink', 'insertVideo']
        ];

        taOptions.defaultFileDropHandler = function() {
            $window.alert('Insert image by dragging is not supported now.');
            return false;
        };
    };

    function getRoom(w) {
        if (w.match_activity || w.activity) {
            var resources = (w.match_activity && w.match_activity.resources) || (w.activity && w.activity.resources);
            return _.findWhere(resources, {resourceType: 'room'});
        } else {
            return w.room;
        }
    }

    function getLocation(w) {
        if (w.match_activity || w.activity) {
            var resources = (w.match_activity && w.match_activity.resources) || (w.activity && w.activity.resources);
            return _.findWhere(resources, {resourceType: 'location'});
        } else {
            return w.location;
        }
    }

    util.getRoomAndLocation = function(w) {
        var room = getRoom(w);
        var location = getLocation(w);
        var res = '';
        if (room) {
            res += _.has(room, 'name') ? room.name : room.lastname;
        }
        if (location) {
            if (room) {
                res += ', ';
            }
            res += _.has(location, 'name') ? location.name : location.lastname;
        }
        return res;
    };

    // getRoomAndLocation reads resourceType off the workout's resources, which
    // under Speedy are placeholders that fill in asynchronously. The table only
    // redraws a placeholder-backed cell if the column declares the placeholder's
    // uid here, so surface the first still-unresolved resource. Once it loads the
    // table rebuilds and re-evaluates, surfacing the next one until all resolve.
    util.roomAndLocationPlaceHolderUid = function(w) {
        if (!w) return null;
        var resources = (w.match_activity && w.match_activity.resources) || (w.activity && w.activity.resources) || [];
        var placeholder = _.find(resources, function(r) { return r && r.is_placeholder; });
        return placeholder ? placeholder.uid : null;
    };

    util.escapeHtml = function(value) {
        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#x2F;'
        };

        return String(value).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    };

    util.getBillingDate = function() {
        var today = new Date();
        var billingDay = $rootScope.billingDay;
        var billingDate = new Date();
        billingDate.setDate(billingDay);

        if (billingDay <= 3) {
            billingDate.setMonth(billingDate.getMonth() + 1);
        }

        if (billingDate.clone().addDays(-3).isPastDate(today)) {
            billingDate.setMonth(billingDate.getMonth() + 1);
        }

        return billingDate;
    };

    util.getDirectDebitBillingDate = function(billingDay) {
        var today = new Date();
        var billingDay = billingDay || $rootScope.billingDay;
        var billingDate = new Date();
        billingDate.setDate(billingDay);

        if (billingDate == today || billingDate.isPastDate(today)) {
            billingDate.setMonth(billingDate.getMonth() + 1);
        }
        return billingDate.yyyymmdd();
    };

    util.calcSmsCapacity = function(text) {
        if (!text) { return; }
        function containsNonLatinCodepoints(s) {
            return /[^\u0000-\u00ff]/.test(s);
        }

        if (containsNonLatinCodepoints(text)) {
            return text.length > 70 ? 66 : 70;
        }
        return text.length > 160 ? 152 : 160;
    };

    util.getSaveStateName = function(locationPath, element) {
        var configName = element[0].getAttribute('config');
        var panel = element.parents().closest('div.panel.panel-default')[0];
        if (!panel) { return locationPath + configName; }
        var identifyName = panel.getAttribute('ng-controller');
        if (!identifyName) {
            identifyName = panel.getElementsByClassName('panel-heading')[0] && panel.getElementsByClassName('panel-heading')[0].innerText;
        }
        var identification = locationPath + configName + identifyName;
        return identification;
    };

    util.getAgeFromPersonalCodeNumber = function(personalCodeNumber) {
        personalCodeNumber = util.normalizePersonalCodeNumber(personalCodeNumber);
        if (!personalCodeNumber) { return; }
        var date = new Date(personalCodeNumber.slice(0,4), Number(personalCodeNumber.slice(4,6))-1,personalCodeNumber.slice(6,8));
        var ageDifMs = Date.now() - date.getTime();
        var ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    };

    util.getShortDate = function(datetime) {
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return datetime.getDate() + ' ' + months[datetime.getMonth()];
    };

    util.getShortTimePeriod = function(activity) {
        var start = activity.hasOwnProperty('start') ? activity.start : activity.startTime;
        var end = activity.hasOwnProperty('end') ? activity.end : activity.endTime;
        return start.hhmm() + ' - ' + end.hhmm();
    };

    $translate.handler = function(fn) {
        var lang = $translate.use();
        var result = fn();
        return function() {
            if(lang === $translate.use()) {
                return result;
            }
            lang = $translate.use();
            result = fn();
            return result;
        };
    };

    var langValue;
    $rootScope.$on('$translateChangeEnd', function() {
        var lang = $translate.use();
        if(lang && lang !== langValue) {
            langValue = lang;
            pubsub.publish('language.changed', lang);
        }
    });

    /**
     * Sets up a customMap field that syncs its keys with a source multiselect field.
     *
     * @param {Object} $scope - Angular scope for $watch
     * @param {Object} fieldSource - The source field whose selected items drive the map keys
     * @param {Object} fieldMap - The field to configure as a customMap
     * @param {Object} options
     * @param {string} options.title - Title for the map field
     * @param {Function} options.visible - Visibility function for the map field
     * @param {Function} options.getNameByKey - Function(key) that returns a display name
     * @param {Function} [options.watchExpr] - Custom watch expression; defaults to plucking IDs from fieldSource
     * @param {Function} [options.enabled] - Optional function; when it returns false, map value is set to null
     */
    util.setupCustomMapField = function($scope, fieldSource, fieldMap, options) {
        function hash(d) {
            if(!d) {return '';}
            var r = [];
            for(var key in d) {
                var value = d[key];
                if(value == null || value === '') {continue;}
                r.push(key + '~' + value);
            }
            return r.sort().join(':');
        }

        fieldMap.title = options.title;
        fieldMap.type = 'customMap';
        fieldMap.visible = options.visible;
        fieldMap.value = {};
        fieldMap.getNameByKey = options.getNameByKey;

        fieldMap.changed = function(field) {
            return field._hash != hash(field.value);
        };
        fieldMap.setValue = function(field, value) {
            field._hash = hash(value);
            return value;
        };
        fieldMap.getValue = function(field) {
            if(!field.value) {return {};}
            var result = {};
            for(var key in field.value) {
                var value = field.value[key];
                if(value == null || value === '') {continue;}
                value = Number(value);
                if(isNaN(value)) {return;}
                result[key] = value;
            }
            return result;
        };

        var watchExpr = options.watchExpr || function() {
            return _.pluck(fieldSource.value, 'id').join(',');
        };

        $scope.$watch(watchExpr, function() {
            if(options.enabled && !options.enabled()) {
                fieldMap.value = null;
                return;
            }
            if(!fieldMap.value) {
                fieldMap.value = {};
            }
            var list = fieldSource.value || [];
            var keys = {};
            list.forEach(function(item) {
                keys[item.id] = true;
                if(item.id in fieldMap.value) {return;}
                fieldMap.value[item.id] = '';
            });
            Object.keys(fieldMap.value).forEach(function(key) {
                if(!(key in keys)) {
                    delete fieldMap.value[key];
                }
            });
        });
    };

    return util;
}]);

util.factory('calendar', ['$filter', '$modal','$rootScope', 'util', function ($filter, $modal,$rootScope, util) {
    var calendar = {};

    calendar.updateTranslation = function(configs) {
        var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        for (var i=0; i < dayNames.length; ++i) {
            dayNames[i] = $filter('translate')(dayNames[i]);
            dayNamesShort[i] = $filter('translate')(dayNamesShort[i]);
        }

        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        for (var i=0; i < monthNames.length; ++i) {
            monthNames[i] = $filter('translate')(monthNames[i]);
            monthNamesShort[i] = $filter('translate')(monthNamesShort[i]);
        }

        var translation = {
            dayNames: dayNames,
            dayNamesShort: dayNamesShort,
            monthNames: monthNames,
            monthNamesShort: monthNamesShort,
            buttonText: {
                today: $filter('translate')('Today'),
                month: $filter('translate')('Month'),
                week: $filter('translate')('Week'),
                day: $filter('translate')('Day'),
                pickdate: $filter('translate')('Pick date'),
                zoom:  $filter('translate')('Zoom'),
                addDailySchedule: $filter('translate')('Add daily schedule'),
            }
        };
        angular.forEach(configs, function(config) {
            angular.extend(config, translation);
        });
    };

    function tooltipString(event) {
        var res = "";
        if(event.start.yyyymmdd)
        {
            res += event.start.hhmm();
            if(event.end) {
                res += " - " + event.end.hhmm() + " ";
            }
        }
        if(event.workoutType){
            if(event.title){
                res += "\n" + event.title + "\n";
            }
            if(event.staffs && event.staffs.length > 0){
                res += `${$filter('translate')('Instructor')}: ${event.staffs.map((staff) => { return `${staff.firstname} ${staff.lastname}`; }).join(", ")}\n`;
            }
            if(event.resources && event.resources.length > 0){

                res += `${$filter('translate')('Resource')}: ${event.resources.map((resource) => { return resource.lastname; }).join(", ")}\n`;
            }
            if(event.space){
                res += `${$filter('translate')('Registered')}: ${event.numBooked} ${$filter("translate")('of')} ${event.space}`;
            }
            else{
                res += `${$filter('translate')('Registered')}: ${event.numBooked}\n`;
            }
        }
        else{
            if(event.resource_booking){

                res +=  "\n" + $rootScope.resourcebookingservices.find(x => x.id == event.resource_booking[0].service_id).name + '\n'

                res += `${$filter('translate')('Customer')}: ${$rootScope.getMember(event.resource_booking[0].booker_id).name}\n`

            }
            if(event.staffs){
                res += `${$filter('translate')('Resource')}: ${event.staffs.map((staff) => { return staff.name; }).join(", ")}\n`;
            }
        }
        if(event.note){
            res += event.note;
        }
        return res;
    }

    calendar.getDefaultConfig = function(smallCalendar) {
        if (util.isSmallScreen()) {
            smallCalendar = true;
        }
        var config = {
            header: {
                left: 'prev,today,next,pickdate,zoom',
                center: 'title',
                right: smallCalendar ? '' : 'month,agendaWeek,agendaDay'
            },
            columnFormat: {
                month: 'dddd',
                week: 'dddd d/M',
                day: 'dddd d/M'
            },
            titleFormat: {
                month: 'MMMM yyyy',                             // September 2009
                week: "MMM d[ yyyy]{ '&#8212;'[ MMM] d, yyyy}", // Sep 7 - 13, 2009
                day: 'dddd, MMM d, yyyy'                        // Tuesday, Sep 8, 2009
            },
            defaultView: smallCalendar ? 'agendaDay' : 'agendaWeek',
            firstDay: 1,
            allDaySlot: false,
            allDayDefault: false,
            timeFormat: 'HH:mm',
            axisFormat: 'HH:mm',
            editable: false,
            weekNumbers: true,
            weekNumberTitle: '',
            eventBorderColor: '#222',
            firstHour: 6,
            slotMinutes: 30,
            // FIXME: Remove this and make it more dynamic
            minTime: '08:00',
            maxTime: '20:00',
            // End of FIXME
            showBottomWorkSchedule: false,
            eventRender: function(event, element) {
                if ((!event.isAnnotation || event.showPointer) && !event.notClickable) {
                    element.css('cursor', 'pointer');
                }
            },
            pickdate: function(calendar) {
                $modal.open({
                    templateUrl: '/views/pickdatemodal.html',
                    controller: 'PickDateModalCtrl',
                    resolve: {
                        date: function() {
                            return calendar.getDate();
                        },
                        infomessage: function() {
                            return '';
                        }
                    }
                }).result.then(function(date) {
                    calendar.gotoDate(date);
                });
            },
            zoom: function() {
                config.slotMinutes = config.slotMinutes == 30 ? 10 : 30;
            },
            setResources: function(resources) {
                this.resources = resources;
                var showInfo = _.some(resources, function(s) { return s.description; });
                if (!showInfo) {
                    this.showInfo = null;
                } else {
                    this.showInfo = function(resource) {
                        $modal.open({
                            templateUrl: 'views/showresource.html',
                            controller: 'ModalCtrl',
                            resolve: {
                                options: function() {
                                    return {title: resource.name, resource: resource};
                                }
                            }
                        });
                    };
                }
            },
            eventMouseover: function(event, jsEvent) {
                var element = $(jsEvent.target).closest('.fc-event');
                if (!element.context.attributes.tooltip) {
                    element.attr({
                        'title': tooltipString(event),
                        'tooltip-append-to-body': true
                    });
                }
            }
        };
        return config;
    };

    calendar.removeMonth = function(config) {
        var headers = config.header.right.split(',');
        headers = headers.filter(function(a) { return a != 'month'; });
        config.header.right = headers.join(',');
    };

    calendar.adjustMinMax = function(config, times, allowOverMidnight) {
        var minmax = util.calculateMinMaxTime(times, undefined, undefined, allowOverMidnight);
        if (minmax.minTime != undefined && (config.minTime != minmax.minTime || config.maxTime != minmax.maxTime)) {
            config.minTime = minmax.minTime;
            config.maxTime = minmax.maxTime;
        }
    };

    calendar.viewChanged = function(scope, view, config) {
        if (config && !config.height) {
            if (view.name === 'month') {
                config.contentHeight = 500;
            }
            else {
                config.contentHeight = 9999;
            }
        }

        var oldVisStart = scope.visStart;
        var oldVisEnd = scope.visEnd;
        scope.visStart = view.visStart;
        scope.visEnd = view.visEnd;
        return (!Date.dateEquals(oldVisStart, scope.visStart) || !Date.dateEquals(oldVisEnd, scope.visEnd));
    };

    calendar.render = function(config) {
        config.calendarObject?.fullCalendar?.('render');
    };

    return calendar;
}]);

util.controller('PickDateModalCtrl', ['$scope', 'date', 'infomessage', function($scope, date, infomessage) {
    $scope.date = date;
    $scope.infomessage = infomessage;
    $scope.$watch('date', function() {
        if (!Date.dateEquals($scope.date, date)) {
            $scope.$close($scope.date);
        }
    });
}]);

util.controller('ChangePaymentTermsModalCtrl', ['$scope', 'payments', 'server', function($scope, payments, server) {
    $scope.title = 'Change payment terms';
    $scope.postUrl = '/api/payment/changePaymentTerms';
    $scope.successTitle = 'Changed payment terms';
    $scope.failedTitle = 'Failed to change payment terms';

    $scope.loadingStatus = {};
    $scope.submit = function() {
        var days = _.findWhere($scope.fields, {name: 'paymentTerms'}).value;
        var data = payments.map(function(p) {
            return {
                id: p.id,
                days: days
            };
        });

        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, data, null, $scope.successTitle, $scope.failedTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.$close();
            }
        });
    };

    $scope.fields = [
        { name: 'paymentTerms', title: 'Payment terms', required: true, type:'number', value: payments[0].days }
    ];
}]);

util.controller('ChangeCtrl', ['$rootScope', '$scope', 'server', 'util', '$location', 'confirm', '$modalStack', function($rootScope, $scope, server, util, $location, confirm, $modalStack) {
    $scope.title = 'Change';

    $scope.getSubmitItem = function() {
        return util.getSubmitItem($scope.getFields ? $scope.getFields() : $scope.fields, $scope.item ? $scope.item.id : undefined);
    };

    $scope.getTitle = function(name) {
        return name && _.findWhere($scope.getFields ? $scope.getFields() : $scope.fields, {name: $rootScope.getRealFormName(name)}).title;
    };

    $scope.getButtonText = function() {
        return  'Change';
    };

    $scope.submit = function() {
        $scope.doSubmit($scope.getSubmitItem());
    };

    $scope.possiblyClose = function(data) {
        if ($scope.callCloseOnSuccess) {
            $scope.$close(data);
        }
    };

    $scope.loadingStatus = {};
    $scope.doSubmit = function(item) {
        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, $scope.postArgs, $scope.successTitle ||  'Information saved', $scope.failedTitle || 'Failed to save information').then(function(result) {
            if (result.success && $scope.afterSubmit) {
                $scope.afterSubmit();
            } else {
                if (!$scope.callCloseOnSuccess || !result.success) {
                    $scope.loadingStatus.loading = false;
                }
            }

            if (result.success) {
                $scope.possiblyClose(result.data);
            }
        });
    };

    $scope.setValues = function(item, option) {
        util.setValues($scope.getFields ? $scope.getFields() : $scope.fields, item, option);
    };

    $scope.valuesChanged = function() {
        var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
        for (var i=0; i < fields.length; ++i) {
            var field = fields[i];
            if (util.valueChanged(field, $scope.item)) {
                return true;
            }
        }

        return false;
    };

    if(!$scope.listenToUrlChange) {
        $scope.listenToUrlChange = $scope.$on('$locationChangeStart', function (event) {
            var changes = $scope.listenToUrlChange.list.map(function(scope) {return scope.valuesChanged();});
            if (!$modalStack.globalForceClose && _.any(changes)) {
                var targetPath = $location.path();
                var targetSearch = $location.search();
                var targetHash = $location.hash();

                event.preventDefault();

                confirm.show('You have unsaved changes. Are you sure you want to close?').then(function () {
                    $scope.listenToUrlChange();
                    $scope.listenToUrlChange.list = [];
                    $location.path(targetPath).search(targetSearch).hash(targetHash);
                });
            }
        });
        $scope.listenToUrlChange.list = [];
    }
    if(!$scope.skipQuittingConfirmation) {
        $scope.listenToUrlChange.list.push($scope);
    }
}]);

util.controller('ChangeModalCtrl', ['$scope', '$controller', 'confirm', '$modalStack', function($scope, $controller, confirm, $modalStack) {
    $controller('ChangeCtrl', {$scope: $scope});

    $scope.callCloseOnSuccess = true;

    if ($scope.unsavedCheck) {
        $scope.unsavedCheck();
    }
    $scope.unsavedCheck = $scope.$on('modal.closing', function(event, reason, closed) {
        if (!closed && !$modalStack.globalForceClose && $scope.valuesChanged()) {
            event.preventDefault();
            confirm.show('You have unsaved changes. Are you sure you want to close?').then(function() {
                $scope.unsavedCheck();
                $scope.$dismiss();
            });
        }
    });
}]);

util.directive('validateField', function() {
    /*
        Use custom field validator.
        Example:
            $scope.fields = [
                {
                    name: 'field',
                    type: 'text',
                    validator: {
                        required: (modelValue, viewValue) => !viewValue,
                        badValue: (modelValue, viewValue) => viewValue.length > 5
                    }
                }
            ]
    */
    return {
      require: 'ngModel',
      link: function($scope, elm, attr, ctrl) {
        if (!$scope.field.validator) return;
        Object.assign(ctrl.$validators, $scope.field.validator);
      }
    };
});

util.directive('badInputValidation', function() {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, modelCtrl) {
            if (typeof $element.prop('validity') === 'undefined') {
                return;
            }

            $element.bind('input', function() {
                var validity = $element.prop('validity');
                $scope.$apply(function() {
                    modelCtrl.$setValidity('badInput', !validity.badInput);
                });
            });
        }
    };
});

util.directive('sliderRangeValidation', function() {
    return {
        scope: {
            field: '='
        },
        link: function($scope) {

            $scope.$watch(function() { return $scope.field.value; }, function() {
                var value = $scope.field.value;
                if (value[1] < value[0]) {
                    var tmp = value[1];
                    value[1] = value[0];
                    value[0] = tmp;
                    $scope.field.value = value;
                }
            });
        }
    };
});

util.directive('emailListValidation', ['$parse', 'util', function($parse, util) {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, $ctrl) {
            var validate = $attrs.emailListValidation && $parse($attrs.emailListValidation);
            var minAttr = $attrs.min && $parse($attrs.min);
            $ctrl.$parsers.unshift(function(viewValue) {
                var validEmail = true;
                var validCount = true;
                if (!!viewValue && validate && validate($scope)) {
                    var emails = viewValue.split(/[\s,\n]+/).filter(function(e) { return !!e; });
                    var min = minAttr($scope);

                    if (!emails || !emails.length || (min != 0 && min > emails.length)) {
                        validCount = false;
                    }

                    for (var i = 0; i < emails.length; i++) {
                        if (!util.isValidMail(emails[i])) {
                            validEmail = false;
                            break;
                        }
                    }
                }

                $ctrl.$setValidity('emailListInvalidEmail', validEmail);
                $ctrl.$setValidity('emailListInvalidEmailCount', validCount);
                return viewValue;
            });
        }
    };
}]);

util.directive('customerinfo2', ['$rootScope', '$filter', 'server', '$injector', function($rootScope, $filter, server, $injector) {
    return {
        restrict: 'E',
        templateUrl: 'views/customerinfo2.html',
        scope: {
            customer: '=',
            config: '=?'
        },
        link : function($scope) {
            if (!$scope.config) {
                $scope.config = {};
            }
            $scope.formatCustomerField = $rootScope.formatCustomerField;
            $scope.formatAmount = $rootScope.formatAmount;
            $scope.getMember = $rootScope.getMember;
            $scope.buildInfoPanel = function() {
                var hasAddress = function() {
                    var f = _.findWhere($rootScope.fields.user, {name: 'address'});
                    return f && f.show;
                };
                var showField = function(field) {
                    var bf = function(name) {
                        return field.name == name && field.builtIn;
                    };
                    var show = field.show && !bf('firstname') && !bf('lastname') && field.type != 'password' && field.type != 'map';
                    if (show) {
                        if (field.name == 'zipCode' || field.name == 'city') {
                            show = !hasAddress();
                        }
                    }
                    return show;
                };
                var hasValue = function(field) {
                    var v = field.getFieldValue();
                    return v !== undefined && v !== null && v.length != 0;
                };
                var getTitle = function(field) {
                    if (field.builtIn && field.name == 'personalCodeNumber' && $scope.customer.company) {
                        return 'Corporate identity';
                    }
                    return field.title;
                };
                var getFieldValue = function(field) {
                    if (field.builtIn && field.name == 'address') {
                        var res = $scope.customer.address || '';
                        if (res.length && ($scope.customer.zipCode || $scope.customer.city)) {
                            res += ', ';
                        }
                        if ($scope.customer.zipCode) {
                            res += $scope.customer.zipCode + ' ';
                        }
                        if ($scope.customer.city) {
                            res += $scope.customer.city;
                        }
                        return res;
                    }
                    return field.builtIn ? $scope.customer[field.name] : $scope.customer.xf[field.name];
                };

                var red = function() {
                    return {color: 'red'};
                };

                $scope.infoFields = $rootScope.fields.user.filter(showField).map(function(field) {
                    return {sort: field.builtIn ? 0 : 1, icon: field.icon, name: field.name, data: field.data, title: getTitle(field), type: field.type, getFieldValue: function() { return getFieldValue(field); } };
                }).filter(hasValue);

                if ($scope.customer.getValueCardAmountForSelectedLegalEntity?.()) {
                    $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'money', type: 'price', title: 'Value card', getFieldValue: function() { return $scope.customer.getValueCardAmountForSelectedLegalEntity(); }, getStyle: function() { return {color: 'green'}; } });
                }

                if ($rootScope.hasPermission('Consent handling')) {
                    $scope.infoFields.push({sort: 2, icon: 'icon fa fa-retweet', name: 'consent', type: 'consent', title: 'Direct debit', getFieldValue: () => $scope.customer});
                }

                if ($rootScope.hasPermission('Show payments') && ($rootScope.hasModule('CardPayment') || $rootScope.hasModule('Adyen')) && $scope.customer.hasSavedCardForSelectedLegalEntity()) {
                    $scope.infoFields.push({sort: 2, icon: 'icon fa fa-retweet', name: 'savedCard', type: 'text', title: 'Card payment', getFieldValue: function() { return $filter('translate')('Has saved card information'); }});
                }

                if ($scope.debts && $scope.debts.length) {
                    $scope.debts.forEach(function(debt) {
                        $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'debt', title: 'Debt', type: 'debt', getFieldValue: function() { return debt; }, getStyle: red });
                    });
                }

                if ($scope.customer.paidBy) {
                    $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'paidBy', title: 'Paid by', type: 'customer', getFieldValue: function() { return $rootScope.getMember($scope.customer.paidBy); } });
                }

                if ($scope.customer.paysFor && $scope.customer.paysFor.length) {
                    $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'paysFor', title: 'Pays for', type: 'customers', getFieldValue: function() { return $scope.customer.paysFor.map($rootScope.getMember); } });
                }

                if ($scope.customer.bookers && $scope.customer.bookers.length) {
                    $scope.infoFields.push({sort: 0, icon: 'icon fa fa-ticket', name: 'bookers', type: 'customers', title: 'Bookers', getFieldValue: function() { return $scope.customer.bookers.map($rootScope.getMember); } });
                }

                if ($scope.customer.canBookFor && $scope.customer.canBookFor.length) {
                    $scope.infoFields.push({sort: 0, icon: 'icon fa fa-ticket', name: 'canBookFor', type: 'customers', title: 'Can book for', getFieldValue: function() { return $scope.customer.canBookFor.map($rootScope.getMember); } });
                }

                if ($rootScope.hasModule('Warning') && $scope.customer.warnings) {
                    $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-warning-sign', name: 'warnings', type: 'number', title: 'Warnings', getFieldValue: function() { return $scope.customer.warnings; }, getStyle: red });
                }

                if ($rootScope.hasModule('Warning') && $scope.customer.warnedUntil) {
                    $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-ban-circle', name: 'warnedUntil', type: 'date', title: 'Warned until', getFieldValue: function() { return $scope.customer.warnedUntil; }, getStyle: red });
                }

                if ($rootScope.hasModule('Entry') && $scope.showEntryCard && $scope.customer.entry_card_value) {
                    $scope.infoFields.push({sort: 0, icon: 'icon glyphicon glyphicon-credit-card', name: 'entry_card', type: 'text', title: 'Entry card', getFieldValue: function() { return $scope.customer.entry_card_value; } });
                }

                if ($scope.config.status && $rootScope.memberstatuses.length) {
                    $scope.infoFields.push({sort: 3, icon: 'icon glyphicon glyphicon-thumbs-up', name: 'status', title: 'Status', type: 'status', getFieldValue: function() { return $scope.customer.status; } });
                }

                if ($rootScope.hasModule('MultiSite')) {
                    $scope.infoFields.push({sort: 0, icon: 'icon glyphicon glyphicon-home', name: 'homesite_id', title: 'Homesite', type: 'text', getFieldValue: function() { return $rootScope.getSite($scope.customer.homesite_id).name; } });
                }

                $scope.infoColumns = {};

                var props = {
                    0: ['homesite_id', 'responsible', 'mail', 'login_key', 'personalCodeNumber', 'birthdate', 'gender', 'phone', 'oldphone', 'address', 'memberNumber', 'interest', 'entry_card', 'bookers', 'canBookFor'],
                    1: [],
                    2: [],
                    3: []
                };

                $scope.infoFields = Array.mergeSort($scope.infoFields, function(a, b) {
                    if (a.sort == b.sort) {
                        var ai = props[a.sort].indexOf(a.name);
                        var bi = props[b.sort].indexOf(b.name);
                        if (ai != -1 && bi != -1) {
                            return ai < bi ? -1 : (ai > bi ? 1 : 0);
                        } else {
                            var atitle = $filter('translate')(a.title);
                            var btitle = $filter('translate')(b.title);
                            return Array.defaultCompare(atitle, btitle);
                        }
                    } else if (a.sort < b.sort) {
                        return -1;
                    } else if (b.sort < a.sort) {
                        return 1;
                    }
                });

                $scope.numInfoColumns = 1;//$scope.infoFields.length < 5 ? 1 : 2;
                var perColumn = Math.floor($scope.infoFields.length / $scope.numInfoColumns);
                var extra_for_first =  $scope.infoFields.length - ($scope.numInfoColumns * perColumn);
                for(var i=0; i < $scope.numInfoColumns; ++i) {
                    var from = i*perColumn + (i > 0 ? extra_for_first : 0);
                    var to = from+perColumn + extra_for_first;
                    $scope.infoColumns[i] = $scope.infoFields.slice(from, to);
                }
            };

            $scope.$watchGroup([
                    function() { return $scope.customer && $rootScope.fields.user && $rootScope.fields.user.length; },
                    function() { return $scope.debts; },
                    function() { return $scope.showEntryCard; }],
                function() {
                    if ($scope.customer && $rootScope.fields.user.length) {
                        $rootScope.waitFor(['memberstatuses']).then($scope.buildInfoPanel);
                }
            });

            $scope.calcHeightOfMap = function() {
                var ci = $('#customerimage').height();
                var cp = $('#customercardinfopanel').height();
                var val = (15 + cp - ci);
                if (!ci || !cp || ci < 50 || !$scope.customer || !$scope.fields.user || !$scope.fields.user.length) {
                    val = 0;
                }
                val = Math.min(ci, val);
                return {height: val + 'px' };
            };

            var getDebts = () => $injector.get('payment').getDebtsList($scope.payments, $scope.customer);

            $scope.getPayments = function() {
                server.get('/api/payment/get', {member: $scope.customer.id}).then(function(payments) {
                    var waitingWatch = $scope.$watch('trainingcards', function() {
                        if ($scope.trainingcards) {
                            angular.forEach(payments, function(payment) {
                                $rootScope.transformPayment(payment);
                            });
                            $scope.payments = payments;
                            $scope.debts = getDebts();
                            waitingWatch();
                        }
                    });
                });
            };

            $scope.getTrainingCards = function() {
                 server.get('/api/trainingcard/get/all', {member_id: $scope.customer.id}).then(function(trainingcards) {
                    $rootScope.waitFor(['trainingcardtypes']).then(function() {
                        angular.forEach(trainingcards, function(trainingcard) {
                            $rootScope.transformTrainingCard(trainingcard);
                        });
                        $scope.trainingcards = trainingcards;
                    });
                });
            };

            $scope.getTrainingCards();
            $scope.getPayments();
        }
    };
}]);

util.directive('simpletable', ['formatter', 'util', function(formatter, util) {
    return {
        restrict: 'E',
        templateUrl: '/views/simpletable.html',
        scope: {
            config: '='
        },
        link: function(scope) {
            scope.getValue = function(column, item) {
                if (typeof column.getValue == 'function') {
                    return column.getValue(item);
                }

                var value = util.getDescendantProp(item, column.field);
                value = formatter.format(column.format, value);

                if (value == undefined || value == null) {
                    value = '';
                }
                if (!_.isString(value)) {
                    value = String(value);
                }
                return value;
            };

            scope.setOrder = function(column) {
                if (scope.orderColumn == column) {
                    scope.orderColumn = '-' + column;
                } else {
                    scope.orderColumn = column;
                }
            };

            if (scope.config.orderColumn) {
                scope.orderColumn = scope.config.orderColumn;
            }
        }
    };
}]);

util.directive('personalCodeNumber', ['$rootScope', '$parse', 'util', function($rootScope, $parse, util) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var type = $parse(attrs.personalCodeNumber)(scope);
            var collision = attrs.personalCodeNumberCollision && $parse(attrs.personalCodeNumberCollision);
            var original = attrs.personalCodeNumberOriginal && $parse(attrs.personalCodeNumberOriginal);
            var validateInvoiceAge = attrs.personalCodeNumberInvoiceAge && $parse(attrs.personalCodeNumberInvoiceAge);
            var field = attrs.field && $parse(attrs.field);

            ctrl.$parsers.unshift(function(viewValue) {
                var valid = !viewValue || util.isValidPersonalCode(viewValue);
                ctrl.$setValidity('personalCodeNumber', valid);
                var unique = true;

                if (original && collision) {
                    var normalizedOriginalValue = util.normalizePersonalCodeNumber(original(scope));
                    var normalizedViewValue = util.normalizePersonalCodeNumber(viewValue);
                    unique = !viewValue || (normalizedOriginalValue == normalizedViewValue) || (valid && type ? $rootScope.isUniquePersonalCodeNumber(type, viewValue) : true);
                    ctrl.$setValidity('personalCodeNumberUnique', unique);

                    if (valid && viewValue) {
                        var x = normalizedViewValue;
                        var c = unique ? null : _.findWhere(type == 'staff' ? $rootScope.staffs : $rootScope.members, {personalCodeNumber: x});
                        collision.assign(scope, c);
                    } else {
                        collision.assign(scope, null);
                    }
                }

                var invoiceAge = true;
                if (valid && validateInvoiceAge && validateInvoiceAge(scope) && viewValue) {
                    var age = util.getAgeFromPersonalCodeNumber(viewValue);
                    invoiceAge = age >= 18;
                }
                if (field) {
                    field(scope).isUnderage = !invoiceAge;
                }
                ctrl.$setValidity('personalCodeNumberInvoiceAge', invoiceAge);

                return (valid && unique && invoiceAge) ? viewValue : undefined;
            });
        }
    };
}]);

util.directive('validateAccountingTemplateTag', ['server', function(server) {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, $ctrl) {
            var tags = [];
            (function() {
                server.get('/api/economy/accountingtemplate/tag/get').then(function(result) {
                    tags = result;
                });
            })();

            $ctrl.$parsers.unshift(function(viewValue) {
                var unique = !_.findWhere(tags, { name: viewValue });
                $ctrl.$setValidity('tagUnique', unique);
                return viewValue;
            });
        }
    };
}]);

util.directive('validateSystemTag', ['$rootScope', function($rootScope) {
    return {
        require: 'ngModel',
        link: function($scope, $element, $attrs, $ctrl) {
            $ctrl.$parsers.unshift(function(viewValue) {
                var unique = !_.findWhere($rootScope.systemtags, { name: viewValue });
                $ctrl.$setValidity('tagUnique', unique);
                return viewValue;
            });
        }
    };
}]);

// http://stackoverflow.com/questions/14378401/dynamic-validation-and-name-in-a-form-with-angularjs
util.directive('dynamicName', ['$compile', '$parse', function($compile, $parse) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 100000,
        link: function(scope, elem) {
            var name = $parse(elem.attr('dynamic-name'))(scope);
            elem.removeAttr('dynamic-name');
            elem.attr('name', name);
            $compile(elem)(scope);
        }
    };
}]);

util.directive('dynamicId', ['$compile', '$parse', function($compile, $parse) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 100000,
        link: function(scope, elem) {
            var id = $parse(elem.attr('dynamic-id'))(scope);
            elem.removeAttr('dynamic-id');
            elem.attr('id', id);
            $compile(elem)(scope);
        }
    };
}]);

util.directive('dynamicController', ['$compile', '$parse',function($compile, $parse) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 550,
        link: function(scope, elem) {
            var name = $parse(elem.attr('dynamic-controller'))(scope);
            elem.removeAttr('dynamic-controller');
            elem.attr('ng-controller', name);
            $compile(elem)(scope);
        }
    };
}]);

util.directive('dynamicTemplate', ['$compile', '$parse',function($compile, $parse) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 550,
        link: function(scope, elem) {
            var template = $parse(elem.attr('dynamic-template'))(scope);
            var t = angular.element(template);
            elem.removeAttr('dynamic-template');
            elem.append($compile(t)(scope));
        }
    };
}]);

util.directive('equalTo', ['$parse', function($parse) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var equalTo = $parse(attrs.equalTo)(scope);
            if (!equalTo) {
                return;
            }

            var getValue = function() {
                return $parse(attrs.ngModel)(scope);
            };
            var getOtherValue = function() {
                return _.findWhere(scope.fields, {name: equalTo}).value;
            };

            var combined = function() {
                return getValue() + getOtherValue();
            };

            scope.$watch(combined, function() {
                var v = getValue();
                var o = getOtherValue();
                var areEqual =  (v == o) || (!v && !o);
                ctrl.$setValidity('equal', areEqual);
            });

            ctrl.$parsers.unshift(function(viewValue) {
                var v = viewValue;
                var o = getOtherValue();
                var areEqual =  (v == o) || (!v && !o);
                ctrl.$setValidity('equal', areEqual);

                return viewValue;
            });
        }
    };
}]);

util.directive('myMaxlength', ['$parse', function($parse) {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var maxlength = Number($parse(attrs.myMaxlength)(scope));
            var savedText = '';

            if (!maxlength) {
                return;
            }

            function fromUser(text) {
                savedText = text;
                maxlength = Number($parse(attrs.myMaxlength)(scope));
                if (text.length > maxlength) {
                    var transformedInput = text.substring(0, maxlength);
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                    return transformedInput;
                }
                return text;
            }
            ngModelCtrl.$parsers.push(fromUser);

            scope.$watch(function() { return Number($parse(attrs.myMaxlength)(scope)); }, function() {
                var changedMaxlength = Number($parse(attrs.myMaxlength)(scope));
                if (savedText.length > changedMaxlength) {
                    var transformedInput = savedText.substring(0, changedMaxlength);
                    var modelValueSetter = $parse(attrs.ngModel).assign;
                    modelValueSetter(scope, transformedInput);
                }
            });
        }
    };
}]);

util.directive('giveFocus', ['$parse', '$timeout', function($parse, $timeout) {
    var NON_TEXT_INPUTS = /^(button|submit|reset|checkbox|radio|file|image|range|color)$/i;

    var isEnteringTextElsewhere = function(elem) {
        var active = document.activeElement;
        if (!active || active === elem) {
            return false;
        }
        if (active.isContentEditable || active.tagName === 'TEXTAREA') {
            return true;
        }
        return active.tagName === 'INPUT' && !NON_TEXT_INPUTS.test(active.type);
    };

    return function(scope, elem, attr) {
        var giveFocus = $parse(attr.giveFocus);
        if (giveFocus(scope)) {
            $timeout(function () {
                // Elements behind an ng-if are relinked on every reload, which would otherwise
                // pull focus out of a field the user is still filling in.
                if (attr.dontStealFocus !== undefined && isEnteringTextElsewhere(elem[0])) {
                    return;
                }
                elem[0].focus();
            });
        }
    };
}]);

util.factory('focus', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
  return function(name) {
    $timeout(function (){
      $rootScope.$broadcast('focusOn', name);
    });
  };
}]);

util.directive('focusOn', [function() {
   return function(scope, elem, attr) {
      scope.$on('focusOn', function(e, name) {
        if(name === attr.focusOn) {
          elem[0].focus();
        }
      });
   };
}]);

util.directive('ngEnter', [function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if(event.which === 13) {
                scope.$apply(function (){
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
}]);

util.factory('modalUtils', ['$modalStack', '$modal', 'server', '$filter', 'alertProvider', function ($modalStack, $modal, server, $filter, alertProvider) {
    return {
        modalsExist: function () {
            return !!$modalStack.getTop();
        },
        getTop: function() {
            return $modalStack.getTop();
        },
        getModalElement: function(selector) {
            if (!$modalStack.getTop()) { return null; }
            return $modalStack.getTop().value.modalDomEl[0].querySelector(selector);
        },
        closeTop: function() {
            $modalStack.dismiss($modalStack.getTop().key);
        },
        closeAllModals: function () {
            $modalStack.dismissAll();
        },
        forceCloseAllModals: function() {
            $modalStack.globalForceClose = true;
            $modalStack.dismissAll();
            $modalStack.globalForceClose = false;
        },
        inactivateModal: function(item, title, content, postUrl) {
            var modalInstance = $modal.open({
                templateUrl: '/views/inactivate.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {title: title, content: content};
                    }
                }
            });

            modalInstance.result.then(function () {
                server.post(postUrl, {id: item.id, active: false}).then(function(result) {
                    var msg;
                    if (result.success) {
                        msg = $filter('translate')('{0} was inactivated').format(title);
                    } else {
                        if (result.data?.type == 'PRODUCT_INCLUDED') {
                            msg = $filter('translate')('CANNOT_INACTIVATE_PRODUCT_INCLUDED_IN');
                            if (result.data.args?.length) msg += ' ' + result.data.args.join(', ');
                        } else {
                            msg = $filter('translate')('Failed to inactivate {0}').format(title);
                        }
                    }
                    alertProvider.show(result.success ? 'success' : 'error', msg, true);
                });
            });
        },
        activateModal: function(item, title, content, postUrl) {
            var modalInstance = $modal.open({
                templateUrl: '/views/activate.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {title: title, content: content};
                    }
                }
            });

            modalInstance.result.then(function () {
                var data = {id: item.id, active: true};
                server.post(postUrl, data, null, '{0} was activated', 'Failed to activate {0}', title);
            });
        }
    };
}]);

util.factory('legalEntity', ['$rootScope', function($rootScope) {
    // A small square in front of the name, in the same colour the company selector
    // shows. It is a scanning aid, not an identifier - the name is what identifies.
    // The table lays a column with its own colorStyle out with flex, so the square is
    // centred by the container and needs no vertical-align of its own. `flex: none`
    // keeps it square when the column is narrow.
    var colorBoxStyle = 'height: 12px; width: 12px; margin-right: 7px; border-radius: 3px; flex: none';

    // Rows either carry their company inline (training cards) or only the site to
    // resolve it through (payments), so both shapes are accepted.
    var entityOf = function(row) {
        if (!row || !row.site_id) {
            return null;
        }

        return $rootScope.getSite(row.site_id)?.legal_entity || null;
    };

    var getName = function(row) {
        return row?.legal_entity_name || entityOf(row)?.name || '';
    };

    var getColor = function(row) {
        return row?.legal_entity_color || entityOf(row)?.color || '';
    };

    return {
        // The 'Legal entity' column, identical in every table that shows one.
        column: function() {
            return {
                field: 'legal_entity_name',
                title: 'Legal entity',
                getValue: getName,
                color: getColor,
                colorStyle: colorBoxStyle,
                visible: () => $rootScope.hasModule('MultipleLegalEntities')
            };
        }
    };
}]);

util.filter('dateEquals', [function() {
    return function(items, date) {
        if (!angular.isUndefined(items) && !angular.isUndefined(date)) {
            var dateTime = date.getTime();
            var arrayToReturn = [];
            for (var i=0; i<items.length; i++) {
                if (items[i].startDate.getTime() == dateTime) {
                    arrayToReturn.push(items[i]);
                }
            }

            return arrayToReturn;
        } else {
            return items;
        }
    };
}]);

// Dependency: https://github.com/grevory/bootstrap-file-input
util.directive('uiFileUpload', [function() {
    return {
        restrict: 'A',
        link: function(scope, ele) {
            ele.bootstrapFileInput();
        }
    };
}]);

util.directive('ngFileSelect', ['$parse', function($parse) {
    return {
        link: function($scope , el, attrs){
            var model = $parse(attrs.ngFileSelect);

            el.bind("change", function(e) {
                var file = (e.srcElement || e.target).files[0];
                var fileReader = new FileReader();
                fileReader.onloadend = function () {
                    $scope.$apply(function() {
                        model.assign($scope, fileReader.result);
                    });
                };
                if (file) {
                    if(attrs.ngFileSelectOption == 'binary') {
                        fileReader.readAsBinaryString(file);
                    } else {
                        fileReader.readAsDataURL(file);
                    }
                }
            });
        }
    };
}]);

util.directive('ngTranslateFileInput', ['$rootScope', '$parse', '$filter', function ($rootScope, $parse, $filter) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var updateText = function() {
                element.siblings().html($filter('translate')(attrs.ngTranslateFileInput));
            };

            var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                updateText();
            });

            element.on('$destroy', function() {
                removeTranslateChangeSuccess();
            });

            updateText();
        }
    };
}]);

util.directive('ngImageAreaSelect', ['$rootScope', '$parse', function ($rootScope, $parse) {
    return {
        link: function(scope , el, attrs){
            var imgAreaSelectInstance;

            el.on('load', function() {
                var img = el.context;
                if (img.src.indexOf('data:') != 0 || img.src == $rootScope.getEmptyImage()) {
                    if (imgAreaSelectInstance) {
                        imgAreaSelectInstance.cancelSelection();
                        imgAreaSelectInstance = null;
                    }
                    return;
                }
                var sw = Math.min(img.naturalWidth, img.naturalHeight);
                var sh = Math.min(img.naturalWidth, img.naturalHeight);
                var sx = (img.naturalWidth - sw) / 2;
                var sy = (img.naturalHeight - sh) / 2;

                var parentId = attrs.ngImageAreaSelectParent ? attrs.ngImageAreaSelectParent : 'content';
                var parent = $('#' + parentId);

                var model = $parse(attrs.ngImageAreaSelect);
                var modelSetter = model.assign;

                imgAreaSelectInstance = $(img).imgAreaSelect({
                    instance: true,
                    imageWidth: img.naturalWidth,
                    imageHeight: img.naturalHeight,
                    aspectRatio: '4:4',
                    x1: sx,
                    y1: sy,
                    x2: sx+sw,
                    y2: sy+sh,
                    handles: true,
                    persistent: true,
                    onSelectEnd: function () {
                        scope.$parent.$apply(function() {
                            modelSetter(scope.$parent, imgAreaSelectInstance.getSelection());
                            if ($rootScope.setupKeypressListener) {
                                $rootScope.setupKeypressListener();
                            }
                        });
                    },
                    parent: parent
                });

                scope.$parent.$apply(function(){
                    modelSetter(scope.$parent, imgAreaSelectInstance.getSelection());
                    if ($rootScope.setupKeypressListener) {
                        $rootScope.setupKeypressListener();
                    }
                });
            });

            el.on('$destroy', function() {
                if (imgAreaSelectInstance) {
                    imgAreaSelectInstance.cancelSelection();
                    imgAreaSelectInstance = null;
                    if ($rootScope.setupKeypressListener) {
                        $rootScope.setupKeypressListener();
                    }
                }
            });
        }
    };
}]);

util.directive('fileModel', ['$rootScope', '$parse', function ($rootScope, $parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind('change', function(){
                scope.$parent.$apply(function(){
                    modelSetter(scope.$parent, attrs.multiple ? element[0].files : element[0].files[0]);
                    if ($rootScope.setupKeypressListener) {
                        $rootScope.setupKeypressListener();
                    }
                });
            });
        }
    };
}]);

util.controller('ModalCtrl', ['$scope', 'options', function($scope, options) {
    $scope.options = options;
    $scope.titleSuffix = options.title;
    $scope.content = options.content;
    $scope.data = {};

    $scope.$on('keypress', function(event, a) {
        if (a.keyCode === 13) {
            if ($scope.options.waitResolve) {
                $scope.yes();
            } else {
                $scope.$close('activate');
            }
        }
    });

    $scope.yes = function() {
        $scope.data.loading = true;
        options.waitResolve(function() {
            $scope.data.loading = false;
            $scope.$close();
        });
    };
}]);

util.factory('confirm', ['$modal', '$q', function($modal, $q) {
    var confirm = {};

    confirm.show = function(content, option) {
        option = option || {};
        var deferred = $q.defer();
        var title = 'Confirm';

        if(option.ladda) {
            var waitResolve = function(callback) {
                deferred.resolve(callback);
            };
            var modalInstance = $modal.open({
                templateUrl: '/views/yesno.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {title: title, content: content, waitResolve: waitResolve, yesButtonText: option.yesButtonText, noButtonText: option.noButtonText, textContent: option.textContent};
                    }
                }
            });

            modalInstance.result.then(function () {}, function() {
                deferred.reject();
            });
        } else {
            var modalInstance = $modal.open({
                templateUrl: '/views/yesno.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {title: title, content: content, yesButtonText: option.yesButtonText, noButtonText: option.noButtonText, textContent: option.textContent};
                    }
                }
            });

            modalInstance.result.then(function (result) {
                deferred.resolve(result);
            }, function() {
                deferred.reject();
            });
        }

        return deferred.promise;
    };

    return confirm;
}]);


util.directive('bankidsigning', ['$rootScope', 'server', 'fileManager', 'live', 'banks', 'util', function($rootScope, server, fileManager, live, banks, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/member/bankidsigningtemplate.html',
        scope: {
            mode: '=', // Enum --> existing, autogiro_member, autogiro_staff
            status: '=?',
            onConsentSigned: '=?',
            contractId: '=?',
            contractUrl: '=?',
            infoText: '=?',
            option: '=?'
        },
        link: function($scope) {

            $scope.getClearingNumber = function() {
                return _.findWhere($scope.fields, {name: 'clearingNumber'}).value;
            };

            $scope.clearingNumberChange = function() {
                var clearingNumber = $scope.getClearingNumber();
                var bank;
                if (clearingNumber) {
                    clearingNumber = String(clearingNumber).substring(0,4);
                    bank = banks.getBank(clearingNumber);
                }

                _.findWhere($scope.fields, {name: 'bank'}).value = bank ? bank.name : '';
            };

            $scope.isAutogiro = function() {
                return $scope.mode == 'autogiro_member';
            };

            $scope.fields = [
                { name: 'preview', title: 'Contract', type: 'button', buttonClass: 'btn-success', buttonTitle: 'Preview', click: function() { $scope.downloadContract(); } },
                { name: 'personalCodeNumber', title: 'Personal code number', required: true, type: 'personalCodeNumber'},
                { name: 'clearingNumber', title: 'Clearing number', required: true, type: 'clearingNumber', max: 99999, change: $scope.clearingNumberChange, visible: $scope.isAutogiro },
                { name: 'bank', title: 'Bank', required: false, type: 'label', visible: $scope.isAutogiro },
                { hint: 'BANK_ACCOUNT_HINT', hintLink: 'https://zoezi.atlassian.net/servicedesk/customer/portal/3/article/86999041', hintLinkText: 'BANK_ACCOUNT_HINT_LINK', visible: $scope.isAutogiro},
                { name: 'account', title: 'Bank account number', required: true, type: 'bankAccountNumber2', getClearingNumber: $scope.getClearingNumber, visible: $scope.isAutogiro }
            ];
            $scope.hideSubmitButton = true;
            $scope.hideRequired = true;
            $scope.noFormValidation = true;
            $scope.loadingStatus = {};

            function setDefaultPersonalCodeNumber() {
                _.findWhere($scope.fields, {name: 'personalCodeNumber'}).value = $rootScope.member && $rootScope.member.personalCodeNumber;
            }

            function getContract() {
                if ($scope.contractId) {
                    $scope.loadingStatus.gettingContract = true;
                    server.get('/api/public/contract/get', { contractId: $scope.contractId }).then(function(contract) {
                        $scope.loadingStatus.gettingContract = false;
                        _.findWhere($scope.fields, {name: 'preview'}).title = contract.name;
                        if (contract.signedAt) {
                            $scope.wasSigned = $scope.progressVisible = true;
                        }
                        else {
                            $scope.wasSigned = $scope.progressVisible = false;
                            setDefaultPersonalCodeNumber();
                        }
                    });
                } else {
                    setDefaultPersonalCodeNumber();
                }
            }
            getContract();

            $scope.downloadContract = function() {
                if ($scope.contractUrl) {
                    fileManager.downloadFileByUrl($scope.contractUrl);
                } else if ($scope.contractId) { // If url hasn't been overridden --> download file by contract id (if set)
                    fileManager.downloadFileByUrl('/api/public/contract/download?contractId='+$scope.contractId);
                }
            };

            var channel2Cancel;
            $scope.signContract = function() {
                var postData = util.getSubmitItem($scope.fields);
                if ($scope.contractId) {
                    postData.contractId = $scope.contractId;
                }

                var postUrl = '';
                switch ($scope.mode) {
                    case 'autogiro_member':
                        postUrl = '/api/memberapi/contract/sign/autogiro';
                        break;
                    case 'autogiro_staff':
                        postUrl = '/api/contract/sign/autogiro';
                        break;
                    case 'existing':
                        postUrl = '/api/public/contract/sign/existing';
                        break;
                }
                var args = {};
                if($scope.option && $scope.option.getUserSession) {
                    var session = $scope.option.getUserSession();
                    if(session) {
                        args.session = session;
                    }
                }
                $scope.loadingStatus.signing = true;
                server.post(postUrl, postData, args).then(function(response) {
                    if (!response.success) {
                        $scope.progressVisible = true;
                        $scope.loadingStatus.signing = false;
                        return;
                    }

                    if (response.data && response.data.aborted) {
                        $scope.progressVisible = true;
                        $scope.handleBankIDResponse(response.data);
                        $scope.loadingStatus.signing = false;
                        return;
                    }

                    if (['unknown', 'Android'].indexOf($rootScope.getMobileOperatingSystem()) === -1) {
                        window.open('bankid:///?redirect=' + encodeURIComponent(window.location.href));
                    }

                    var signId = response.data && response.data.signId;

                    if(channel2Cancel) {
                        channel2Cancel();
                    }
                    if (signId) {
                        channel2Cancel = live.channel2(null, signId, function(response) {
                            if (response.status === 'consent') {
                                channel2Cancel();
                                channel2Cancel = null;
                                if(response.consent && $scope.onConsentSigned) {
                                    $scope.onConsentSigned(response);
                                }
                            } else {
                                $scope.handleBankIDResponse(response);
                            }
                        });
                        $scope.$on('$destroy', function() {
                            if(channel2Cancel) {
                                setTimeout(function() {
                                    if(channel2Cancel) {
                                        channel2Cancel();
                                        channel2Cancel = null;
                                    }
                                }, 10000);
                            }
                        });
                    }
                });
            };

            $scope.retry = function() {
                $scope.progressVisible = $scope.signingAlreadyInProgress = $scope.errorOccured = $scope.userAborted = false;
                $scope.errorMessageKey = null;
            };

            $scope.handleBankIDResponse = function(resp) {
                if (resp.aborted) {
                    $scope.progressVisible = true;
                    $scope.errorOccured = true;
                    $scope.loadingStatus.signing = false;
                    if (resp.status === 'USER_CANCEL') {
                        $scope.userAborted = true;
                    }
                    else if (resp.status === 'ALREADY_IN_PROGRESS') {
                        $scope.signingAlreadyInProgress = true;
                    }
                    else if (resp.status === 'WRONG_PERSONAL_CODE') {
                        $scope.errorMessageKey = 'BANKID_WRONG_PERSONAL_CODE';
                    }
                    else if (resp.status === 'PERSONAL_CODE_IN_USE') {
                        $scope.errorMessageKey = 'BANKID_PERSONAL_CODE_IN_USE';
                    }
                } else if (resp.status === 'COMPLETE') {
                    $scope.wasSigned = true;
                    $scope.loadingStatus.signing = false;
                }

                if(!$rootScope.$$phase) {
                    $scope.$apply(); // Apply changes to template
                }
            };
        }
    };
}]);

util.directive('socialmediashare', ['$modal', '$rootScope', function($modal, $rootScope) {
    return {
        restrict: 'E',
        template: '<div><a ng-href="https://www.facebook.com/sharer.php?u={{href()}}" target="_blank"><img style="width: 30px; height:30px;" src="assets/img/facebook.png"></img></a><a ng-href="https://twitter.com/intent/tweet?url={{href()}}" target="_blank"><img style="width:30px;height:30px;margin-left:2px" src="assets/img/twitter.png"></img></a><a href="" ng-click="mail()"><img style="width: 30px; height:30px;margin-left:2px" src="assets/img/mail.png"></img></a></div>',
        scope: {
            workout: '='
        },
        link: function($scope) {
            $scope.href = function() {
                return encodeURIComponent(document.location.href);
            };
            $scope.mail = function() {
                $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: ['$scope', 'util', 'server', function($scope, util, server) {
                        $scope.title = 'Share';
                        $scope.hideRequired = true;
                        $scope.loadingStatus = {};
                        $scope.fields = [
                            {name: 'name', title: 'Your name', type: 'text', readonly: !!$rootScope.member, required: true },
                            {name: 'mail', title: 'Your friend\'s e-mail address', type: 'email', required: true}
                        ];

                        _.findWhere($scope.fields, {name: 'name'}).value = $rootScope.member ? $rootScope.member.name : '';

                        $scope.submit = function() {
                            $scope.loadingStatus.loading = true;
                            var data = util.getSubmitItem($scope.fields);
                            data.link = document.location.href;
                            data.name = _.findWhere($scope.fields, {name: 'name'}).value;
                            server.post('/api/public/share', data).then(function() {
                                $scope.loadingStatus.loading = false;
                                $scope.$close();
                            });
                        };
                    }]
                });
            };
        }
    };
}]);

util.factory('script', ['$q',  function($q) {
    var script = {};

    script.load = function(src, isLoaded) {
        var deferred = $q.defer();

        if (!isLoaded || !isLoaded()) {
            var script = document.createElement('script');
            script.src = src;
            script.onload = function () {
                deferred.resolve();
            };

            document.head.appendChild(script);
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    };

    return script;
}]);

util.factory('stripe', ['$rootScope', 'script', function($rootScope, script) {
    var stripe = {};

    stripe.load = function() {
        var isLoaded = function() { return typeof Stripe != "undefined"; };

        /*
        return script.load('https://js.stripe.com/v2/', isLoaded).then(function() {

            // This is from gs2970 selfcheckout stripeimplementation, saved if needed in future stripeintegration.
            if ($rootScope.isStaffApp) { Stripe.setPublishableKey($rootScope.cardpaymentkey); return; }

            $rootScope.getCardPaymentKey().then(function(key) {
                Stripe.setPublishableKey(key);
            });
        });
        */

        return script.load('https://js.stripe.com/v3/', isLoaded);

    };

    return stripe;
}]);

util.factory('googlemap', ['script', '$q', function(script, $q) {
    var googlemap = {};

    googlemap.standardLocation = {lat: 58.404588, lng: 15.603761};

    googlemap.load = function() {
        if (!googlemap.deferred) {
            googlemap.deferred = $q.defer();
        }

        var isLoaded = function() { return typeof google != "undefined" && typeof google.maps != "undefined" && typeof google.maps.Map != "undefined"; };
        if (!window.googlemapLoad) {
            window.googlemapLoad = function() {
                googlemap.deferred.resolve();
            };
        }
        return script.load('https://maps.googleapis.com/maps/api/js?callback=googlemapLoad&key=AIzaSyAkUAkjyqsYAb-FCtpUY7WdetIQUv1-slQ', isLoaded).then(function() {
            return googlemap.deferred.promise;
        });
    };

    googlemap.stringToLatLng = function(x) {
        if (x) {
            var p = x.split(',');
            if (p.length == 2) {
                return {lat: Number(p[0]), lng: Number(p[1])};
            }
        }
    };

    googlemap.latLngToString = function(latlng) {
        return latlng.lat() + ',' + latlng.lng();
    };

    return googlemap;
}]);

util.factory('leafletmap', ['$q', function($q) {
    var leafletmap = {};

    leafletmap.standardLocation = [58.404588, 15.603761];

    leafletmap.load = function() {
        if (leafletmap.deferred) {
            return leafletmap.deferred.promise;
        }

        leafletmap.deferred = $q.defer();

        if (window.leaflet && window.leaflet.map) {
            leafletmap.deferred.resolve(window.leaflet);
            return leafletmap.deferred.promise;
        }

        // Load CSS
        if (!document.querySelector('link[href*="leaflet.css"]')) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }

        // Load JS
        var script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.onload = function() {
            var checkLeaflet = function(attempts) {
                if (window.leaflet && window.leaflet.map) {
                    leafletmap.deferred.resolve(window.leaflet);
                } else if (attempts > 0) {
                    setTimeout(function() { checkLeaflet(attempts - 1); }, 50);
                } else {
                    leafletmap.deferred.reject(new Error('Leaflet failed to initialize'));
                }
            };
            checkLeaflet(20);
        };
        script.onerror = function() {
            leafletmap.deferred.reject(new Error('Failed to load Leaflet'));
        };
        document.head.appendChild(script);

        return leafletmap.deferred.promise;
    };

    leafletmap.stringToLatLng = function(x) {
        if (x) {
            var p = x.split(',');
            if (p.length == 2) {
                return [Number(p[0]), Number(p[1])];
            }
        }
        return null;
    };

    leafletmap.latLngToString = function(latlng) {
        return latlng.lat + ',' + latlng.lng;
    };

    return leafletmap;
}]);

util.directive('mapmarker', ['$rootScope', 'googlemap', 'leafletmap', 'util', 'alertProvider', function($rootScope, googlemap, leafletmap, util, alertProvider) {
    return {
        restrict: 'A',
        scope: {
            position: '=',
            control: '=',
            zoom: '=',
            readonly: '='
        },
        link: function(scope, element) {
            var useLeaflet = $rootScope.hasFlag('flag-leaflet-maps');

            if (useLeaflet) {
                // Leaflet implementation
                leafletmap.load().then(function(L) {
                    var map, marker;
                    var center = leafletmap.stringToLatLng(scope.position) || leafletmap.standardLocation;

                // Create Leaflet map
                map = L.map(element[0], {
                    attributionControl: false,
                    zoomControl: true
                }).setView(center, scope.zoom || 8);

                // Add OpenStreetMap tiles
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

                // Add marker if position exists
                if (scope.position) {
                    marker = L.marker(center).addTo(map);
                }

                // Click handler for non-readonly maps
                if (!scope.readonly) {
                    map.on('click', function(e) {
                        $rootScope.$apply(function() {
                            scope.position = e.latlng.lat + ',' + e.latlng.lng;
                            if (marker) {
                                marker.setLatLng(e.latlng);
                            } else {
                                marker = L.marker(e.latlng).addTo(map);
                            }
                        });
                    });
                }

                // Geocoding support (control.getFromAddress)
                if (scope.control) {
                    scope.control.loading = false;
                    scope.control.getFromAddress = function(address, city) {
                        // Use Nominatim for geocoding (OpenStreetMap)
                        if (!address) address = '';
                        var query = encodeURIComponent(address + ', ' + city);
                        var url = 'https://nominatim.openstreetmap.org/search?format=json&q=' + query + '&limit=1';

                        scope.control.loading = true;
                        var userAgent = 'Zoezi/' + ($rootScope.currentStaff && $rootScope.currentStaff.version ? $rootScope.currentStaff.version : '1.0');
                        fetch(url, {
                            headers: { 'User-Agent': userAgent }
                        })
                        .then(function(response) { return response.json(); })
                        .then(function(results) {
                            if (results && results.length > 0) {
                                var lat = parseFloat(results[0].lat);
                                var lon = parseFloat(results[0].lon);
                                $rootScope.$apply(function() {
                                    scope.position = lat + ',' + lon;
                                    var latlng = [lat, lon];
                                    if (marker) {
                                        marker.setLatLng(latlng);
                                    } else {
                                        marker = L.marker(latlng).addTo(map);
                                    }
                                    map.panTo(latlng);
                                    scope.control.loading = false;
                                });
                            } else {
                                $rootScope.$apply(function() {
                                    scope.control.loading = false;
                                    alertProvider.show('error', 'Could not find address. Please check the address and try again.');
                                });
                            }
                        })
                        .catch(function() {
                            $rootScope.$apply(function() {
                                scope.control.loading = false;
                                alertProvider.show('error', 'Failed to get position from address. Please try again.');
                            });
                        });
                    };
                }

                // Watch for position changes
                scope.$watch('position', function(newValue, oldValue) {
                    if (newValue != oldValue && newValue) {
                        var latlng = leafletmap.stringToLatLng(newValue);
                        if (latlng) {
                            map.setView(latlng, scope.zoom || 8);
                            if (marker) {
                                marker.setLatLng(latlng);
                            }
                        }
                    }
                });

                    // Fix map rendering after element becomes visible (for dialogs)
                    util.waitForVisible(element).then(function() {
                        if (map) {
                            setTimeout(function() { map.invalidateSize(); }, 100);
                        }
                    });

                }); // End of loadLeaflet().then()

            } else {
                // Google Maps implementation (original code)
                googlemap.load().then(function() {
                    var map;
                    var marker = null;

                    var addMarker = function(position) {
                        marker = new google.maps.Marker({
                            position: googlemap.stringToLatLng(position),
                            map: map
                        });
                    };

                    var createMap = function() {
                        map = new google.maps.Map(element[0], {
                            zoom: scope.zoom || 8,
                            center: googlemap.stringToLatLng(scope.position) || googlemap.standardLocation,
                            disableDefaultUI: true
                        });

                        if (!scope.readonly) {
                            map.addListener('click', function(event) {
                                $rootScope.$apply(function() {
                                    scope.position = googlemap.latLngToString(event.latLng);
                                    if (marker) {
                                        marker.setPosition(event.latLng);
                                    } else {
                                        addMarker(scope.position);
                                    }
                                });
                            });
                        }

                        if (scope.position) {
                            addMarker(scope.position);
                        }
                    };

                    createMap();

                    if (scope.control) {
                        scope.control.loading = false;
                        scope.control.getFromAddress = function(address, city) {
                            var geocoder = new google.maps.Geocoder();
                            if (!address) {
                                address = '';
                            }
                            scope.control.loading = true;
                            geocoder.geocode({'address': address + ', ' + city}, function(results, status) {
                                if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                                    var loc = results[0].geometry.location;
                                    $rootScope.$apply(function() {
                                        scope.position = googlemap.latLngToString(loc);
                                        if (marker) {
                                            marker.setPosition(loc);
                                        } else {
                                            addMarker(scope.position);
                                        }
                                        map.panTo(loc);
                                        scope.control.loading = false;
                                    });
                                } else {
                                    $rootScope.$apply(function() {
                                        scope.control.loading = false;
                                        alertProvider.show('error', 'Could not find address. Please check the address and try again.');
                                    });
                                }
                            });
                        };
                    }

                    scope.$watch('position', function(newValue, oldValue) {
                        if (newValue != oldValue) {
                            map.setZoom(scope.zoom || 8);
                            map.setCenter(googlemap.stringToLatLng(scope.position));
                            marker.setPosition(googlemap.stringToLatLng(scope.position));
                        }
                    });
                });
            }
        }
    };
}]);

util.directive('mymap', ['$rootScope', 'googlemap', 'leafletmap', 'util', function($rootScope, googlemap, leafletmap, util) {
    return {
        restrict: 'A',
        scope: {
            items: '=',
            position: '=',
            zoom: '=',
            triggers: '='
        },
        link: function(scope, element) {
            var useLeaflet = $rootScope.hasFlag('flag-leaflet-maps');

            if (useLeaflet) {
                // Leaflet implementation for multiple markers
                leafletmap.load().then(function(L) {
                    var map, markers = [];
                    var center = leafletmap.stringToLatLng(scope.position) || leafletmap.standardLocation;

                    map = L.map(element[0]).setView(center, scope.zoom || 8);
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

                    var addMarkers = function() {
                        angular.forEach(scope.items, function(item) {
                            if (item.position) {
                                var latlng = leafletmap.stringToLatLng(item.position);
                                if (latlng) {
                                    var marker = L.marker(latlng).addTo(map);
                                    if (item.name) marker.bindTooltip(item.name, {className: 'mymap-tooltip'});
                                    var itemId = isNaN(item) ? item.id : item;
                                    var href = ($rootScope.staffnext ? '/staff' : '') + '#/customer/show/' + itemId;
                                    marker.on('click', function(e) {
                                        if (e.originalEvent.ctrlKey || e.originalEvent.metaKey) {
                                            window.open(href, '_blank');
                                        } else {
                                            $rootScope.$apply(function() {
                                                $rootScope.gotoCustomer(item);
                                            });
                                        }
                                    });
                                    markers.push(marker);
                                }
                            }
                        });
                    };

                    var updateMap = function() {
                        for (var i=0; i < markers.length; ++i) {
                            map.removeLayer(markers[i]);
                        }
                        markers = [];
                        addMarkers();
                    };

                    addMarkers();
                    util.waitForVisible(element).then(function() {
                        if (map) setTimeout(function() { map.invalidateSize(); }, 100);
                    });

                    var removeServerChange;
                    if (scope.triggers) {
                        removeServerChange = $rootScope.$on('serverChange', function (event, message) {
                            if (scope.triggers.indexOf(message.type) != -1) {
                                updateMap();
                            }
                        });
                    }

                    scope.$watchCollection('items', function() {
                        updateMap();
                    });

                    scope.$on('destroy', function() {
                        if (removeServerChange) removeServerChange();
                    });
                });

            } else {
                // Google Maps implementation (original)
                googlemap.load().then(function() {
                    var map;
                    var markers = [];
                    var createMap = function() {
                        map = new google.maps.Map(element[0], {
                            zoom: scope.zoom || 8,
                            center: googlemap.stringToLatLng(scope.position) || googlemap.standardLocation
                        });
                    };

                    var addMarkers = function() {
                        angular.forEach(scope.items, function(item) {
                            if (item.position) {
                                var marker = new google.maps.Marker({
                                    position: googlemap.stringToLatLng(item.position),
                                    map: map,
                                    title: item.name
                                });
                                marker.addListener('click', function() {
                                    $rootScope.$apply(function() {
                                        $rootScope.gotoCustomer(item);
                                    });
                                });
                                markers.push(marker);
                            }
                        });
                    };

                    var updateMap = function() {
                        for (var i=0; i < markers.length; ++i) {
                            markers[i].setMap(null);
                        }
                        markers = [];
                        addMarkers();
                    };

                    createMap();
                    addMarkers();

                    var removeServerChange;
                    if (scope.triggers) {
                        removeServerChange = $rootScope.$on('serverChange', function (event, message) {
                            if (scope.triggers.indexOf(message.type) != -1) {
                                updateMap();
                            }
                        });
                    }

                    scope.$watchCollection('items', function() {
                        updateMap();
                    });

                    scope.$on('destroy', function() {
                        if (removeServerChange) {
                            removeServerChange();
                        }
                    });
                });
            }
        }
    };
}]);

util.directive('syncCalendar', ['$window', '$timeout', function($window, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'views/member/synccalendartemplate.html',
        scope: {
            memberurl: '=',
            showgroup: '='
        },
        link: function($scope) {

            var groupWorkoutUrl = '/api/public/icalendar/get/groupworkouts';

            $scope.validInput = undefined;
            var validateInput = function() {
                $scope.validInput = !!($scope.memberurl || $scope.showgroup);
            };
            $timeout(validateInput, 10);

            var getLink = function(calendarUrl) {
                var baseUrl = 'webcal://' + window.location.host;
                return baseUrl + calendarUrl;
            };

            $scope.getCalendar = function() {
                $window.location.href = getLink($scope.memberurl);
            };
            $scope.getGoogleCalendar = function() {
                window.open('https://www.google.com/calendar/render?cid=' + getLink($scope.memberurl));
            };

            $scope.getCalendarGroup = function() {
                $window.location.href = getLink(groupWorkoutUrl);
            };
            $scope.getGoogleCalendarGroup = function() {
                window.open('https://www.google.com/calendar/render?cid=' + getLink(groupWorkoutUrl));
            };
        }
    };
}]);

util.factory('skipReload', ['$route', '$rootScope', function ($route, $rootScope) {
    return function () {
        var lastRoute = $route.current;
        var un = $rootScope.$on('$locationChangeSuccess', function () {
            $route.current = lastRoute;
            un();
        });
    };
}]);


util.filter('join', [function() {
    return function(items, sep, key) {
        if(!Array.isArray(items)) {
            return items;
        }
        sep = sep || ', ';
        if(key) {
            items = items.map(function(item) {
                return item[key];
            });
        }
        return items.filter(angular.identity).join(sep);
    };
}]);

util.factory('pdf', ['script', 'util', function(script, util) {
    var pdf = {};

    pdf.load = function() {
        var isLoaded = function() { return typeof PDFDocument != "undefined"; };
        return script.load('/assets/js/libs/pdfkit.min.js', isLoaded);
    };

    pdf.download = function(stream, filename) {
        var blob = stream.toBlob('application/pdf');
        util.download(filename, null, null, blob);
    };

    return pdf;
}]);

util.factory('excel', ['script',  'util', function(script, util) {
    var excel = {};

    excel.load = function() {
        var isLoaded = function() { return typeof XLSX != "undefined"; };
        return script.load('/assets/js/libs/xlsx.core.min.js', isLoaded);
    };

    excel.download = function(data, filename) {
        var blob = new Blob([data], { type: 'application/vnd.ms-excel' });
        util.download(filename, null, null, blob);
    };

    return excel;
}]);

util.factory('echartslib', ['script', function(script) {
    var echartslib = {};

    echartslib.load = function() {
        var isLoaded = function() { return typeof echarts != "undefined"; };
        return script.load('/assets/js/libs/echarts.min.js', isLoaded);
    };

    return echartslib;
}]);

util.directive('staticInclude', ['$http', '$templateCache', '$compile', function($http, $templateCache, $compile) {
    return function(scope, element, attrs) {
        var templatePath = attrs.staticInclude;
        $http.get(templatePath, { cache: $templateCache }).success(function(response) {
            var contents = element.html(response).contents();
            $compile(contents)(scope);
        });
    };
}]);

// Fork of https://github.com/grevory/bootstrap-file-input
// Changes done: made it work in strict mode
//               made it possible to not show file name (default)

/*
  Bootstrap - File Input
  ======================

  This is meant to convert all file input tags into a set of elements that displays consistently in all browsers.

  Converts all
  <input type="file">
  into Bootstrap buttons
  <a class="btn">Browse</a>

*/
(function($) {

$.fn.bootstrapFileInput = function() {

  this.each(function(i,elem){

    var $elem = $(elem);

    // Maybe some fields don't need to be standardized.
    if (typeof $elem.attr('data-bfi-disabled') != 'undefined') {
      return;
    }

    // Set the word to be displayed on the button
    var buttonWord = 'Browse';

    if (typeof $elem.attr('title') != 'undefined') {
      buttonWord = $elem.attr('title');
    }

    var className = '';

    if (!!$elem.attr('class')) {
      className = ' ' + $elem.attr('class');
    }

    // Now we're going to wrap that input field with a Bootstrap button.
    // The input will actually still be there, it will just be float above and transparent (done with the CSS).
    $elem.wrap('<a class="file-input-wrapper btn btn-default ' + className + '"></a>').parent().prepend($('<span></span>').html(buttonWord));
  })

  // After we have found all of the file inputs let's apply a listener for tracking the mouse movement.
  // This is important because the in order to give the illusion that this is a button in FF we actually need to move the button from the file input under the cursor. Ugh.
  .promise().done( function(){

    // As the cursor moves over our new Bootstrap button we need to adjust the position of the invisible file input Browse button to be under the cursor.
    // This gives us the pointer cursor that FF denies us
    $('.file-input-wrapper').mousemove(function(cursor) {

      var input, wrapper,
        wrapperX, wrapperY,
        inputWidth, inputHeight,
        cursorX, cursorY;

      // This wrapper element (the button surround this file input)
      wrapper = $(this);
      // The invisible file input element
      input = wrapper.find("input");
      // The left-most position of the wrapper
      wrapperX = wrapper.offset().left;
      // The top-most position of the wrapper
      wrapperY = wrapper.offset().top;
      // The with of the browsers input field
      inputWidth= input.width();
      // The height of the browsers input field
      inputHeight= input.height();
      //The position of the cursor in the wrapper
      cursorX = cursor.pageX;
      cursorY = cursor.pageY;

      //The positions we are to move the invisible file input
      // The 20 at the end is an arbitrary number of pixels that we can shift the input such that cursor is not pointing at the end of the Browse button but somewhere nearer the middle
      var moveInputX = cursorX - wrapperX - inputWidth + 20;
      // Slides the invisible input Browse button to be positioned middle under the cursor
      var moveInputY = cursorY- wrapperY - (inputHeight/2);

      // Apply the positioning styles to actually move the invisible file input
      input.css({
        left:moveInputX,
        top:moveInputY
      });
    });

    var btnScope = angular.element('.file-input-wrapper input[type=file]').scope();
    var isExpoApp = btnScope.isExpoApp && btnScope.isExpoApp();
    var expoPlatform = btnScope.expoDevicePlatform && btnScope.expoDevicePlatform();
    if (isExpoApp && expoPlatform == 'android') {
        $('body').on('click', '.file-input-wrapper input[type=file]', function() {
            var mimeType = btnScope.mimeType || '*/*';
            btnScope.expoAsyncCall('documentPicker', { mimeType: mimeType, multiple: !!$(this).prop('multiple') }, function(filedata) {
                var fileB64 = filedata.file;
                var filename = filedata.name;

                // https://stackoverflow.com/a/16245768
                var byteCharacters = atob(fileB64);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file = new Blob([byteArray], {type: mimeType});

                btnScope.expoUpload(file, filename);
            });
        });
    }

    $('body').on('change', '.file-input-wrapper input[type=file]', function(){

      var fileName;
      fileName = $(this).val();

      // Remove any previous file names
      $(this).parent().next('.file-input-name').remove();
      if (!!$(this).prop('files') && $(this).prop('files').length > 1) {
        fileName = $(this)[0].files.length+' files';
        //$(this).parent().after('<span class="file-input-name">'+$(this)[0].files.length+' files</span>');
      }
      else {
        // var fakepath = 'C:\\fakepath\\';
        // fileName = $(this).val().replace('C:\\fakepath\\','');
        fileName = fileName.substring(fileName.lastIndexOf('\\')+1,fileName.length);
      }

      var selectedFileNamePlacement = $(this).data('filename-placement');
      if (selectedFileNamePlacement === 'inside') {
        // Print the fileName inside
        $(this).siblings('span').html(fileName);
        $(this).attr('title', fileName);
      } else if (selectedFileNamePlacement === 'outside') {
        // Print the fileName aside (right after the the button)
        $(this).parent().after('<span class="file-input-name">'+fileName+'</span>');
      }
    });

  });

};

// Add the styles before the first stylesheet
// This ensures they can be easily overridden with developer styles
var cssHtml = '<style>'+
  '.file-input-wrapper { overflow: hidden; position: relative; cursor: pointer; z-index: 1; }'+
  '.file-input-wrapper input[type=file], .file-input-wrapper input[type=file]:focus, .file-input-wrapper input[type=file]:hover { position: absolute; top: 0; left: 0; cursor: pointer; opacity: 0; filter: alpha(opacity=0); z-index: 99; outline: 0; }'+
  '.file-input-name { margin-left: 8px; }'+
  '</style>';
$('link[rel=stylesheet]').eq(0).before(cssHtml);

})(jQuery);

/**
 * http://www.openjs.com/scripts/events/keyboard_shortcuts/
 * Version : 2.01.A
 * By Binny V A
 * License : BSD
 */
window.shortcut = {
    all_shortcuts: {},//All the shortcuts are stored in this array
    add: function(shortcut_combination,callback,opt) {
        //Provide a set of default options
        var default_options = {
            'type':'keydown',
            'propagate':false,
            'disable_in_input':false,
            'target':document,
            'keycode':false
        };

        if (!opt) {
            opt = default_options;
        } else {
            for(var dfo in default_options) {
                if (typeof opt[dfo] == 'undefined') {
                    opt[dfo] = default_options[dfo];
                }
            }
        }

        var ele = opt.target;
        if (typeof opt.target == 'string') {
            ele = document.getElementById(opt.target);
        }
        shortcut_combination = shortcut_combination.toLowerCase();

        //The function to be called at keypress
        var func = function(e) {
            e = e || window.event;

            if(opt.disable_in_input) { //Don't enable shortcut keys in Input, Textarea fields
                var element;
                if (e.target) {
                    element=e.target;
                } else if(e.srcElement) {
                    element=e.srcElement;
                }
                if(element.nodeType==3) {
                    element=element.parentNode;
                }

                if(element.tagName == 'INPUT' || element.tagName == 'TEXTAREA') {
                    return;
                }
            }

            //Find Which key is pressed
            var code;
            if (e.keyCode) {
                code = e.keyCode;
            } else if (e.which) {
                code = e.which;
            }
            var character = String.fromCharCode(code).toLowerCase();

            if (code == 188) {
                character=","; //If the user presses , when the type is onkeydown
            }
            if (code == 190) {
                character="."; //If the user presses , when the type is onkeydown
            }

            var keys = shortcut_combination.split("+");
            //Key Pressed - counts the number of valid keypresses - if it is same as the number of keys, the shortcut function is invoked
            var kp = 0;

            //Work around for stupid Shift key bug created by using lowercase - as a result the shift+num combination was broken
            var shift_nums = {
                "`":"~",
                "1":"!",
                "2":"@",
                "3":"#",
                "4":"$",
                "5":"%",
                "6":"^",
                "7":"&",
                "8":"*",
                "9":"(",
                "0":")",
                "-":"_",
                "=":"+",
                ";":":",
                "'":"\"",
                ",":"<",
                ".":">",
                "/":"?",
                "\\":"|"
            };
            //Special Keys - and their codes
            var special_keys = {
                'esc':27,
                'escape':27,
                'tab':9,
                'space':32,
                'return':13,
                'enter':13,
                'backspace':8,

                'scrolllock':145,
                'scroll_lock':145,
                'scroll':145,
                'capslock':20,
                'caps_lock':20,
                'caps':20,
                'numlock':144,
                'num_lock':144,
                'num':144,

                'pause':19,
                'break':19,

                'insert':45,
                'home':36,
                'delete':46,
                'end':35,

                'pageup':33,
                'page_up':33,
                'pu':33,

                'pagedown':34,
                'page_down':34,
                'pd':34,

                'left':37,
                'up':38,
                'right':39,
                'down':40,

                'f1':112,
                'f2':113,
                'f3':114,
                'f4':115,
                'f5':116,
                'f6':117,
                'f7':118,
                'f8':119,
                'f9':120,
                'f10':121,
                'f11':122,
                'f12':123
            };

            var modifiers = {
                shift: { wanted:false, pressed:false},
                ctrl : { wanted:false, pressed:false},
                alt  : { wanted:false, pressed:false},
                meta : { wanted:false, pressed:false}   //Meta is Mac specific
            };

            if (e.ctrlKey) {  modifiers.ctrl.pressed = true; }
            if (e.shiftKey) { modifiers.shift.pressed = true; }
            if (e.altKey) { modifiers.alt.pressed = true; }
            if (e.metaKey) { modifiers.meta.pressed = true; }

            var k;
            for (var i=0; k=keys[i],i<keys.length; i++) {
                //Modifiers
                if (k == 'ctrl' || k == 'control') {
                    kp++;
                    modifiers.ctrl.wanted = true;

                } else if (k == 'shift') {
                    kp++;
                    modifiers.shift.wanted = true;

                } else if (k == 'alt') {
                    kp++;
                    modifiers.alt.wanted = true;
                } else if (k == 'meta') {
                    kp++;
                    modifiers.meta.wanted = true;
                } else if (k.length > 1) { //If it is a special key
                    if(special_keys[k] == code) {
                        kp++;
                    }

                } else if (opt.keycode) {
                    if (opt.keycode == code) {
                        kp++;
                    }

                } else { //The special keys did not match
                    if(character == k) {
                        kp++;
                    }
                    else {
                        if(shift_nums[character] && e.shiftKey) { //Stupid Shift key bug created by using lowercase
                            character = shift_nums[character];
                            if(character == k) {
                                kp++;
                            }
                        }
                    }
                }
            }

            if (kp == keys.length &&
                        modifiers.ctrl.pressed == modifiers.ctrl.wanted &&
                        modifiers.shift.pressed == modifiers.shift.wanted &&
                        modifiers.alt.pressed == modifiers.alt.wanted &&
                        modifiers.meta.pressed == modifiers.meta.wanted) {
                callback(e);

                if (!opt.propagate) { //Stop the event
                    //e.cancelBubble is supported by IE - this will kill the bubbling process.
                    e.cancelBubble = true;
                    e.returnValue = false;

                    //e.stopPropagation works in Firefox.
                    if (e.stopPropagation) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                    return false;
                }
            }
        };
        this.all_shortcuts[shortcut_combination] = {
            'callback':func,
            'target':ele,
            'event': opt.type,
            'realcallback': callback
        };
        //Attach the function with the event
        if (ele.addEventListener) {
            ele.addEventListener(opt.type, func, false);
        } else if(ele.attachEvent) {
            ele.attachEvent('on'+opt.type, func);
        } else {
            ele['on'+opt.type] = func;
        }
    },

    //Remove the shortcut - just specify the shortcut and I will remove the binding
    remove: function(shortcut_combination) {
        shortcut_combination = shortcut_combination.toLowerCase();
        var binding = this.all_shortcuts[shortcut_combination];
        delete(this.all_shortcuts[shortcut_combination]);
        if (!binding) {
            return;
        }
        var type = binding.event;
        var ele = binding.target;
        var callback = binding.callback;

        if (ele.detachEvent) {
            ele.detachEvent('on'+type, callback);
        } else if(ele.removeEventListener) {
            ele.removeEventListener(type, callback, false);
        } else {
            ele['on'+type] = false;
        }
    }
};

util.controller('AddCtrl', ['$scope', 'server', 'util', 'confirm', '$modalStack', function($scope, server, util, confirm, $modalStack) {

    $scope.loadingStatus = {};

    $scope.getTitle = function(name) {
        if (name) {
            var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
            var field = _.findWhere(fields.filter(function(f) { return !f.visible || f.visible(); }), {name: util.getRealFormName(name)});
            return field && field.title;
        }
    };

    $scope.getButtonText = function() {
        return 'Add';
    };

    $scope.getSubmitItem = function() {
        var item = {};
        var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
        for (var i=0; i < fields.length; ++i) {
            var field = fields[i];
            if (!field.type || !field.name || (field.visible && !field.visible(field) && !field.save)) {
                continue;
            }
            var value = util.getValueForField(field);

            if (field.splitted_name && field.splitted_name.length > 0) {
                var sn = field.splitted_name;
                if (!item[sn[0]]) {
                    item[sn[0]] = {};
                }
                item[sn[0]][sn[1]] = value;
            } else if (field.name.indexOf('.') != -1) {
                var parts = field.name.split('.');
                if (!item[parts[0]]) {
                    item[parts[0]] = {};
                }
                item[parts[0]][parts[1]] = value;
            } else {
                item[field.name] = value;
            }
        }
        return item;
    };

    $scope.resetForm = function(scope) {
        var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
        for (var i=0; i < fields.length; ++i) {
            var field = fields[i];
            if (field.type == 'image') {
                delete field.imageSrc;
                delete field.selection;
            }
            delete field.value;
        }

        for(var cs = scope.$$childHead; cs; cs = cs.$$nextSibling) {
            if (cs.form) {
                cs.form.$setPristine();
            }
            $scope.resetForm(cs);
        }

        if ($scope.setInitialValues) {
            $scope.setInitialValues();
        }
    };

    $scope.possiblyClose = function(data) {
        if ($scope.callCloseOnSuccess) {
            $scope.$close(data);
        }
    };

    $scope.submit = function() {
        $scope.doSubmit($scope.getSubmitItem());
    };

    $scope.doSubmit = function(item) {
        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, $scope.successTitle || 'Item added', $scope.failedTitle || 'Failed to add item', $scope.itemTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.resetForm($scope);
                $scope.possiblyClose(result.data, item);
            }
        });
    };

    $scope.valuesHasBeenEntered = function() {
        for(var cs = $scope.$$childHead; cs; cs = cs.$$nextSibling) {
            if (cs.form) {
                if (!cs.form.$pristine) {
                    return true;
                }
            }
        }
    };

    if ($scope.unsavedCheck) {
        $scope.unsavedCheck();
    }

    $scope.unsavedCheck = $scope.$on('modal.closing', function(event, reason, closed) {
        if (!closed && !$modalStack.globalForceClose && $scope.valuesHasBeenEntered()) {
            event.preventDefault();
            confirm.show('You have unsaved changes. Are you sure you want to close?').then(function() {
                $scope.unsavedCheck();
                $scope.$dismiss();
            });
        }
    });
}]);

util.directive('staticInclude', ['$http', '$templateCache', '$compile', function($http, $templateCache, $compile) {
    return function(scope, element, attrs) {
        var templatePath = attrs.staticInclude;
        $http.get(templatePath, { cache: $templateCache }).success(function(response) {
            var contents = element.html(response).contents();
            $compile(contents)(scope);
        });
    };
}]);

util.directive('infoscreenBookingSlot', [function() {
    return {
        restrict: 'E',
        templateUrl: '/views/member/infoscreenbookingslottemplate.html',
        scope: {
            booking: '='
        },
        link: function($scope) { // Non-modular so far (built for two slots)

            $scope.available = function() {
                if (!$scope.booking.slots || $scope.booking.slots.length === 0) {
                    return true;
                }

                var now = new Date();
                var time = Date.newFull($scope.booking.slots[0].time);
                var endTime = time.clone();
                endTime.addMinutes($scope.booking.slots[0].duration);
                return !(time.getTime() < now.getTime() && now.getTime() < endTime.getTime());
            };

            $scope.formatTime = function(time, duration) {
                if (!time) {
                    return '00:00 - 00:00';
                }
                var time = Date.newFull(time);
                var endTime = time.clone();
                endTime.addMinutes(duration);
                return time.hhmm() + ' - ' + endTime.hhmm();
            };

            $scope.formatXF = function(xf) {
                if (!xf) { return ''; }

                var section = xf['Avdelning/Mottagning/Vårdcentral'];
                var area = xf['Verksamhet/Klinik'];

                var output = '';
                [section, area].forEach(function(field) {
                    if (!field) { return; }
                    output += (' | ' + field);
                });
                return output;
            };
        }
    };
}]);

util.directive('infoscreenEquipmentBookingSlot', [function() {
    return {
        restrict: 'E',
        templateUrl: '/views/member/infoscreenequipmentbookingslottemplate.html',
        scope: {
            info: '='
        },
        link: function($scope) {

            $scope.formatTime = function(time, duration) {
                if (!time) {
                    return '00:00 - 00:00';
                }
                var time = Date.newFull(time);
                var endTime = time.clone();
                endTime.addMinutes(duration);
                return time.hhmm() + ' - ' + endTime.hhmm();
            };

            $scope.formatInfoText = function(xf) {
                if (!xf) { return ''; }
                var section = xf['Avdelning/Mottagning/Vårdcentral'];
                return section || '';
            };
        }
    };
}]);

util.directive('invoiceAdditionalInformation', ['util', function(util) {
    return {
        restrict: 'E',
        templateUrl: 'views/member/invoiceadditionalinformationtemplate.html',
        scope: {
            payment: '=',
            auth: '='
        },
        link: function($scope) {
            $scope.hideSubmitButton = true;

            var updateData = function() {
                var item = util.getSubmitItem($scope.fields);
                $scope.payment.invoice = item;
            };
            var isUnderage = function() {
                var member = $scope.auth.getMember();
                if (member) {
                    if (member.noPcode) { return true; }
                    if (member.personalCodeNumber) {
                        var age = util.getAgeFromPersonalCodeNumber(member.personalCodeNumber);
                        return age < 18;
                    }
                }
                return !!_.findWhere($scope.fields, { name: 'personalCodeNumber' }).isUnderage;
            };
            var canBillCompany = function() {
                if (isUnderage()) { return false; }
                return $scope.payment.method.company_invoice;
            };
            var companyInvoice = function() {
                return _.findWhere($scope.fields, {name: 'company_invoice'}).value && canBillCompany();
            };
            var missingPersonalCodeNumber = function() {
                var user = $scope.auth.getMember();
                return user && !user.personalCodeNumber;
            };
            var hasAddress = function() {
                return $scope.auth.hasAddress() || ($scope.payment.sentToPaidBy && $scope.payment.canBePaidBy());
            };

            $scope.fields = [
                { hint: 'INVOICE_ADDITIONAL_INFO_MESSAGE', visible: function() { return canBillCompany() && companyInvoice() || !hasAddress() || missingPersonalCodeNumber(); } },
                { name: 'personalCodeNumber', title: 'Personal code number', type: 'personalCodeNumber', visible: missingPersonalCodeNumber, change: updateData, validateInvoiceAge: true },
                { name: 'company_invoice', title: 'Bill company', type: 'checkbox', visible: canBillCompany, change: updateData },
                { name: 'name', title: 'Companyname', type: 'text', visible: companyInvoice, change: updateData },
                { name: 'mail', title: 'E-mail', type: 'email', visible: companyInvoice, change: updateData },
                { name: 'address', title: 'Address', type: 'textarea', visible: function() { return companyInvoice() || !hasAddress(); }, onChange: updateData },
                { name: 'zipCode', title: 'Zip code', type: 'zipCode', visible: function() { return companyInvoice() || !hasAddress(); }, change: updateData },
                { name: 'city', title: 'City', type: 'text', visible: function() { return companyInvoice() || !hasAddress(); }, change: updateData }
            ];
        }
    };
}]);

util.directive('modalDialog', function(){
    return {
        restrict: 'AC',
        link: function($scope, element) {
            var draggableStr = "draggableModal";
            var header = $(".modal-header", element);

            header.on('mousedown', function(mouseDownEvent) {
                var modalDialog = element;
                var offset = header.offset();

                modalDialog.addClass(draggableStr).parents().on('mousemove', function(mouseMoveEvent) {
                    $("." + draggableStr, modalDialog.parents()).offset({
                        top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                        left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                    });
                }).on('mouseup', function() {
                    modalDialog.removeClass(draggableStr);
                });
            });
        }
    };
});

angular.module('ui.bootstrap.modal', ['ui.bootstrap.transition'])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function () {
    return {
      createNew: function () {
        var stack = [];

        return {
          add: function (key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function (key) {
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function () {
            return stack[stack.length - 1];
          },
          remove: function (key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function () {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function () {
            return stack.length;
          }
        };
      }
    };
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('modalBackdrop', ['$timeout', function ($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'template/modal/backdrop.html',
      link: function (scope, element, attrs) {
        scope.backdropClass = attrs.backdropClass || '';

        scope.animate = false;

        //trigger CSS transitions
        $timeout(function () {
          scope.animate = true;
        });
      }
    };
  }])

  .directive('modalWindow', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        index: '@',
        animate: '='
      },
      replace: true,
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'template/modal/window.html';
      },
      link: function (scope, element, attrs) {
        element.addClass(attrs.windowClass || '');
        scope.size = attrs.size;

        $timeout(function () {
          // trigger CSS transitions
          scope.animate = true;

          /**
           * Auto-focusing of a freshly-opened modal element causes any child elements
           * with the autofocus attribute to lose focus. This is an issue on touch
           * based devices which will show and then hide the onscreen keyboard.
           * Attempts to refocus the autofocus element via JavaScript will not reopen
           * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
           * the modal element if the modal does not contain an autofocus element.
           */
          if (!element[0].querySelectorAll('[autofocus]').length) {
            element[0].focus();
          }
        });

        scope.close = function (evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop && modal.value.backdrop != 'static' && (evt.target === evt.currentTarget) && evt.clientX <= evt.target.clientWidth) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };
      }
    };
  }])

  .directive('modalTransclude', function () {
    return {
      link: function($scope, $element, $attrs, controller, $transclude) {
        $transclude($scope.$parent, function(clone) {
          $element.empty();
          $element.append(clone);
        });
      }
    };
  })

  .factory('$modalStack', ['$transition', '$timeout', '$document', '$compile', '$rootScope', '$$stackedMap',
    function ($transition, $timeout, $document, $compile, $rootScope, $$stackedMap) {

      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var $modalStack = {};

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex){
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeAfterAnimate(domEl, scope, emulateTime, done) {
        // Closing animation
        scope.animate = false;

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          domEl.remove();
          if (done) {
            done();
          }
        }

        var transitionEndEventName = $transition.transitionEndEventName;
        if (transitionEndEventName) {
          // transition out
          var timeout = $timeout(afterAnimating, emulateTime);

          domEl.bind(transitionEndEventName, function () {
            $timeout.cancel(timeout);
            afterAnimating();
            scope.$apply();
          });
        } else {
          // Ensure this call is async
          $timeout(afterAnimating);
        }
      }

      function checkRemoveBackdrop() {
          //remove backdrop if no longer needed
          if (backdropDomEl && backdropIndex() == -1) {
            var backdropScopeRef = backdropScope;
            removeAfterAnimate(backdropDomEl, backdropScope, 150, function () {
              backdropScopeRef.$destroy();
              backdropScopeRef = null;
            });
            backdropDomEl = undefined;
            backdropScope = undefined;
          }
      }

      function removeModalWindow(modalInstance) {

        var body = $document.find('body').eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;

        //clean up the stack
        openedWindows.remove(modalInstance);

        //remove window DOM element
        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function() {
          modalWindow.modalScope.$destroy();
          body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
          checkRemoveBackdrop();
        });
      }

      $document.bind('keydown', function (evt) {
        var modal;

        if (evt.which === 27) {
          modal = openedWindows.top();
          if (modal && modal.value.keyboard) {
            evt.preventDefault();
            $rootScope.$apply(function () {
              $modalStack.dismiss(modal.key, 'escape key press');
            });
          }
        }
      });

      $modalStack.open = function (modalInstance, modal) {

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard
        });

        var body = $document.find('body').eq(0),
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.index = currBackdropIndex;
          var angularBackgroundDomEl = angular.element('<div modal-backdrop></div>');
          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
          body.append(backdropDomEl);
        }

        var angularDomEl = angular.element('<div modal-window></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'size': modal.size,
          'index': openedWindows.length() - 1,
          'animate': 'animate'
        }).html(modal.content);

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        body.append(modalDomEl);
        body.addClass(OPENED_MODAL_CLASS);
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
    };

      $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
    };

      $modalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function () {
        return openedWindows.top();
      };

      return $modalStack;
    }])

  .provider('$modal', function () {

    var $modalProvider = {
      options: {
        backdrop: true, //can be also false or 'static'
        keyboard: true
      },
      $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack',
        function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {

          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $http.get(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl,
                {cache: $templateCache}).then(function (result) {
                  return result.data;
              });
          }

          function getResolvePromises(resolves) {
            var promisesArr = [];
            angular.forEach(resolves, function (value) {
              if (angular.isFunction(value) || angular.isArray(value)) {
                promisesArr.push($q.when($injector.invoke(value)));
              }
            });
            return promisesArr;
          }

          $modal.open = function (modalOptions) {

            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              close: function (result) {
                $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));


            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {

              var modalScope = (modalOptions.scope || $rootScope).$new();
              modalScope.$close = modalInstance.close;
              modalScope.$dismiss = modalInstance.dismiss;

              var ctrlInstance, ctrlLocals = {};
              var resolveIter = 1;

              var content = $.parseHTML(tplAndVars[0]);
              var headerIndex = _.findIndex(content, function(e) { return e.classList && e.classList.contains('modal-header'); });
              if (headerIndex !== -1) {
                content[headerIndex].append(document.createElement('modalguide'));
                modalScope.$getGuide = function() { return null; }; // Implement this in modal controller
              }
              content = _.map(content, function(e) { return e.outerHTML; }).join('');

              //controllers
              if (modalOptions.controller) {
                ctrlLocals.$scope = modalScope;
                ctrlLocals.$modalInstance = modalInstance;
                angular.forEach(modalOptions.resolve, function (value, key) {
                  ctrlLocals[key] = tplAndVars[resolveIter++];
                });

                ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                if (modalOptions.controllerAs) {
                  modalScope[modalOptions.controllerAs] = ctrlInstance;
                }
              }

              $modalStack.open(modalInstance, {
                scope: modalScope,
                deferred: modalResultDeferred,
                content: content,
                backdrop: modalOptions.backdrop,
                keyboard: modalOptions.keyboard,
                backdropClass: modalOptions.backdropClass,
                windowClass: modalOptions.windowClass,
                windowTemplateUrl: modalOptions.windowTemplateUrl,
                size: modalOptions.size
              });

            }, function resolveError(reason) {
              modalResultDeferred.reject(reason);
            });

            templateAndResolvePromise.then(function () {
              modalOpenedDeferred.resolve(true);
            }, function () {
              modalOpenedDeferred.reject(false);
            });

            return modalInstance;
          };

          return $modal;
        }]
    };

    return $modalProvider;
  });

// Use ng-mousedown instead of ng-click to close dialog. Fixes GS-3707
angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modal/window.html",
    "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-mousedown=\"close($event)\">\n" +
    "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
    "</div>");
}]);

util.controller('OpenBankIdCtrl', ['$rootScope', '$scope', 'autostarttoken', function($rootScope, $scope, autostarttoken) {
    function openBankIdApp(autostarttoken) {
        var os = $rootScope.getMobileOperatingSystem();
        var redirect_uri = ''; // window.location.href
        if (os == 'iOS') {
            window.location.href = 'https://app.bankid.com/?autostarttoken={0}&redirect={1}'.format(autostarttoken, encodeURIComponent(redirect_uri));
        } else {
            window.open('bankid:///?autostarttoken={0}&redirect={1}'.format(autostarttoken, encodeURIComponent(redirect_uri)));
        }
    }

    $scope.titleSuffix = 'Open BankID';
    $scope.openBankId = function() {
        openBankIdApp(autostarttoken);
        $scope.$close();
    };
}]);

util.controller('LoginModalCtrl', ['$rootScope', '$scope', 'server', 'facebook', 'options', 'live', '$modal', '$location', '$routeParams', function($rootScope, $scope, server, facebook, options, live, $modal, $location, $routeParams) {
    options = options || {};

    $scope.loadingStatus = {};
    $scope.data = {mode: options.forgot ? 'forgot' : 'login', mail: options.mail, password: options.password, passwordLimit: 6, canClose: options.canClose, qrcode: ''};
    if (location.hostname == 'zoezidev.se' || window.__devenv) {
        $scope.data.passwordLimit = 3;
    }

    function updateIsSupport() {
        $scope.isSupport = $location.path() == '/support';
        if ($scope.isSupport) {
            $scope.loginsettings = {bankid: true};
        } else {
            $scope.loginsettings = options.settings;
        }

        var pcode = $location.search().pcode;
        $location.search('pcode', null);
        if (pcode && $scope.isSupport) {
            $scope.data.personalCodeNumber = pcode;
        }
    }
    updateIsSupport();

    $scope.canOpenOnAnotherDevice = function() {
        var os = $rootScope.getMobileOperatingSystem();
        return os != 'unknown' && !(os == 'Android' && $rootScope.isApp());
    };

    $scope.loginFb = function() {
        facebook.login({type: 'login'});
    };

    $scope.login = function(login, password) {
        var url = (location.pathname == '/staff' || location.pathname == '/angularstaff') ? '/api/v8.0/staff/login' : '/api/v8.0/memberapi/login';
        server.post(url, {login: login, password: password}).then(function(result) {
            if (result.success) {
                $rootScope.whenAuthenticated(result.data);
                if ($scope.hasOwnProperty('$close')) {
                    $scope.$close();
                } else if ($routeParams.workoutId) {
                    var workoutId = $routeParams.workoutId;
                    $location.search('workoutId', null);
                    var site = $rootScope.selectedSite ? $rootScope.selectedSite.id : 1;
                    $location.path('/schedule/'+site+'/'+workoutId);
                } else {
                    $location.path('/');
                }
            } else {
                $scope.data.errorMessage = result.data.message;
                $scope.data.password ="";
            }
        });
    };

    function showOpenBankIdModal(autostarttoken) {
        $modal.open({
            templateUrl: 'views/openbankid.html',
            controller: 'OpenBankIdCtrl',
            resolve: {
                autostarttoken: function() {
                    return autostarttoken;
                }
            }
        });
    }

    $scope.openBankId = function() {
        $scope.loadingStatus.bankid = true;
        if ($scope.data.bankidautostarttoken) {
            if ($rootScope.isExpoApp()) {
                $rootScope.expoPostMessage('bankid', $scope.data.bankidautostarttoken);
            } else {
                showOpenBankIdModal($scope.data.bankidautostarttoken);
            }

        };
    };

    $scope.initBankID = function() {
        if ($scope.loginsettings && $scope.loginsettings.bankid) {
            $scope.loadingStatus.bankid = true;
            var url = $scope.isSupport ? '/api/user/login_support_bankid' : '/api/user/login_bankid';
            server.post(url, null, {}).then(function(result) {
                if (result.success) {
                    $scope.data.bankidautostarttoken = result.data.autostarttoken;
                    $scope.abortBankId = function() {
                        server.post('/api/user/login_bankid_cancel', null, {id: result.data.authId});
                        $scope.loadingStatus.bankid = false;
                        $scope.data.qrcode = null;
                    };

                    live.channel2($scope, result.data.authId, function(resp) {
                        if (resp.status == 'complete') {
                            document.cookie = `session=${resp.session_id}; Path=/; Expires=${new Date('2040-01-01T10:00:00Z').toUTCString()}; Secure`;
                            $rootScope.whenAuthenticated(resp.data);
                            $scope.$close(resp.data);
                        } else if (resp.status == 'qrcode') {
                            $scope.data.qrcode = resp.qrcode;
                            $scope.$apply();
                        } else {
                            $scope.data.qrcode = null;
                            $scope.errorMessage = resp.error;
                            $scope.loadingStatus.bankid = false;
                            $scope.$apply();
                        }
                    });
                    if (!$scope.data.otherdevice && $scope.canOpenOnAnotherDevice()) $scope.openBankId();
                } else {
                    $scope.data.errorMessage = result.data.message;
                    $scope.loadingStatus.bankid = false;
                }
            });
        }
    };

    $scope.resetMail = function(mail) {
        server.post('/api/memberapi/requestResetPassword', null, {mail: mail}).then(function(result) {
            if (result.success) {
                $scope.data.successMessage = 'An email with info has been sent';
                $scope.data.errorMessage = null;
                $scope.data.mode = 'login';
            } else {
                $scope.data.successMessage = null;
                $scope.data.errorMessage = result.data.message;
            }
        });
    };

    $scope.resetPhone = function(phone) {
        server.post('/api/memberapi/requestResetPassword', null, {phone: phone}).then(function(result) {
            if (result.success) {
                $scope.data.successMessage = 'An SMS with info has been sent';
                $scope.data.errorMessage = null;
                $scope.data.mode = 'reset';
            } else {
                $scope.data.successMessage = null;
                $scope.data.errorMessage = result.data.message;
            }
        });
    };

    $scope.save = function(password) {
        var hash = $scope.data.hash || $scope.data.code;
        server.post('/api/memberapi/resetPassword', null, {newPassword: password, hash: hash}).then(function(result) {
            if (result.success) {
                $scope.login(result.data.mail, password);
            } else {
                $scope.data.successMessage = null;
                $scope.data.errorMessage = result.data.message;
            }
        });
    };

    if (!$rootScope.isStaffApp) {
        $rootScope.fetchSettings.then(function() {
            $scope.contactinfo = angular.copy($rootScope.settings.contactinfo);
            $scope.contactinfo.cityText = ($scope.contactinfo.visit_zipCode?$scope.contactinfo.visit_zipCode + ' ': '') + ($scope.contactinfo.visit_city || '');
        });
    }

    if (options.mail && options.password) {
        $scope.login(options.mail, options.password);
    }

    var removeRouteListener = $rootScope.$on("$routeChangeSuccess", updateIsSupport);
    $scope.$on('$destroy', removeRouteListener);
}]);

util.factory('facebook', ['util', function(util) {
    var facebook = {};

    var encodeState = function(x) {
        return encodeURIComponent(btoa(JSON.stringify(x)));
    };

    var decodeState = function(x) {
        return JSON.parse(atob(decodeURIComponent(x)));
    };

    var getHashParams = function(hash) {
        var h = hash || window.location.hash;
        if (!h || h.length == 0) {
            return {};
        }

        if (h.indexOf('#/') == 0) {
            h = h.substring(2);
        }

        var res = {};
        var p = h.split('&');
        for (var i=0; i < p.length; ++i) {
            var ei = p[i].indexOf('=');
            var k;
            var v;
            if (ei != -1) {
                k = p[i].substring(0, ei);
                v = p[i].substring(ei+1);
            } else {
                k = p[i];
                v = '';
            }
            res[k] = v;
        }
        return res;
    };

    /*continueCallback, appId, fbzoezi*/

    facebook.setup = function(options) {
        facebook.options = options;
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/sv_SE/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        window.fbAsyncInit = function() {
            FB.init({
                appId      : facebook.options.appId,
                xfbml      : true,
                version    : 'v4.0'
            });
        };
    };

    facebook.checkLoginStatus = function(hash) {
        var h = getHashParams(hash);
        if (h.access_token && h.state) {
            var state = decodeState(h.state);
            facebook.options.continueLogin(state, h.access_token);
        }
    };

    facebook.login = function(state) {
        if (util.isInIframe()) {
            FB.login(function(response) {
                if (response.status === 'connected') {
                    facebook.options.continueLogin(state, response.authResponse.accessToken);
                }
            }, {scope: 'public_profile,email'});
        } else {
            state.redirect = window.location.href.split('#')[0];
            var encodedState = encodeState(state);
            var url = 'https://www.facebook.com/dialog/oauth?scope=public_profile,email&state=' + encodedState + '&client_id=513936233994052&response_type=token&redirect_uri=' + encodeURIComponent('https://service.zoezi.se/fbauth/');
            window.location.href = url;
        }
    };

    return facebook;
}]);

util.factory('debounce', ['$timeout','$q', function($timeout, $q) {
  // The service is actually this function, which we call with the func
  // that should be debounced and how long to wait in between calls
  return function debounce(func, wait, immediate) {
    var timeout;
    // Create a deferred object that will be resolved when we need to
    // actually call the func
    var deferred = $q.defer();
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if(!immediate) {
          deferred.resolve(func.apply(context, args));
          deferred = $q.defer();
        }
      };
      var callNow = immediate && !timeout;
      if ( timeout ) {
        $timeout.cancel(timeout);
      }
      timeout = $timeout(later, wait);
      if (callNow) {
        deferred.resolve(func.apply(context,args));
        deferred = $q.defer();
      }
      return deferred.promise;
    };
  };
}]);

util.controller('TrainingCardPeriodCtrl', ['$scope', '$controller', 'util', 'card', 'options', function($scope, $controller, util, card, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Get collection receipt';
    options = options || {};

    $scope.fields = [
        {name: 'fromDate', title: 'From date', type: 'date', required: true, value: new Date(new Date().getFullYear(), 0, 1)},
        {name: 'toDate', title: 'To date', type: 'date', required: true, value: new Date(new Date().getFullYear(), 11, 31)},
        {name: 'mail', title: 'Send mail', type: 'checkbox', visible: () => options.mail }
    ];

    $scope.getTotalAmount = function() {
        var item = $scope.getSubmitItem();
        var payments = card.payments.filter(function(p) {
            let getPaymentDate = function(payment) {
                if (payment.attempts.length) {
                    var attempt = util.getInkassoPaidAttempt(payment) || payment.attempts[payment.attempts.length-1];
                    return Date.newFull(attempt.time).yyyymmdd();
                }
            }
            let paid = getPaymentDate(p);
            return p.status == 'paid' && paid && paid >= item.fromDate && paid <= item.toDate;
        });
        var amount = 0;
        payments.forEach(function(p) {
            amount += Number(p.amount);
        });
        return amount;
    };

    $scope.canSubmit = function() {
        var item = $scope.getSubmitItem();
        return item.fromDate && item.toDate && item.fromDate <= item.toDate && $scope.getTotalAmount() > 0;
    };

    $scope.submit = function() {
        $scope.$close($scope.getSubmitItem());
    };
}]);

util.directive('clearOnInput', [function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            active: '=clearOnInput'
        },
        link: function($scope, $element, $attrs, $ngModelCtrl) {
            var clearHiddenText = function(newValue) {
                $scope.active = false;
                $ngModelCtrl.$setViewValue(newValue);
                $ngModelCtrl.$render();
            };

            $element.bind('input', function(event) {
                if ($scope.active) {
                    clearHiddenText(event.originalEvent.data);
                }
            });

            $element.bind('paste', function() {
                if ($scope.active) {
                    clearHiddenText('');
                }
            });
        }
    };
}]);

util.filter('orderByNumeric', [function() {
    return function(array, property) {
        return Array.mergeSort(array, function(a, b) {
            return a[property].localeCompare(b[property]);
        });
    };
}]);

util.controller('MailMultiModalCtrl', ['$rootScope', '$scope', 'sendlist', 'server', 'options', function($rootScope, $scope, sendlist, server, options) {
    $scope.title = 'Send mail';
    $scope.loadingStatus = {};
    var options = options || {};

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var members = sendlist.map(function(s) { return s.id; }).filter(function(s) { return s !== $rootScope.member.id; });
        var message = _.findWhere($scope.fields, {name: 'message'}).value;
        var subject = _.findWhere($scope.fields, {name: 'subject'}).value;
        var replyTo = $rootScope.member.mail;
        var mail = {members: members, staffs: [], others: [], message: message, from: null, subject: subject, replyTo: replyTo, options: options};
        server.post('/api/mail/send', mail, null, 'Mail sent', 'Failed to send mail').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.getTitle = function(name) {
        return $rootScope.getFormTitle($scope.fields, name);
    };

    $scope.fields = [
        {name: 'subject', title: 'Subject', required: true, type: 'text' },
        {name: 'message', title: 'Message', required: true, type: 'htmleditor' }
    ];
}]);

util.directive('corporateIdentity', ['$rootScope', '$parse', 'util', function($rootScope, $parse, util) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var collision = $parse(attrs.corporateIdentityCollision);
            var original = $parse(attrs.corporateIdentityOriginal);
            var field = $parse(attrs.corporateIdentityField)(scope);
            ctrl.$parsers.unshift(function(viewValue) {
                var valid = !viewValue || util.isValidCorporateIdentity(viewValue);
                ctrl.$setValidity('corporateIdentity', valid);

                var normalizedOriginalValue = util.normalizeCorporateIdentity(original(scope));
                var normalizedViewValue = util.normalizeCorporateIdentity(viewValue);
                var normalizedViewValuePcode = util.normalizePersonalCodeNumber(viewValue);
                var c;
                if(field.unique === false) {
                    c = true;
                } else {
                    c = valid ? !_.findWhere($rootScope.members, {personalCodeNumber: normalizedViewValue, company: true}) : true;
                    if (c) {
                        c = !_.findWhere($rootScope.members, {personalCodeNumber: normalizedViewValuePcode, company: false});
                    }
                }
                var unique = !viewValue || (normalizedOriginalValue == normalizedViewValue) || c;
                ctrl.$setValidity('corporateIdentityUnique', unique);
                collision.assign(scope, c);

                return (valid && unique) ? viewValue : undefined;
            });
        }
    };
}]);

util.directive('multibutton', [function() {
    return {
        restrict: 'E',
        templateUrl: 'views/multibutton.html',
        scope: {
            config: '=',
            value: "="
        },
        link: function() {
        }
    };
}]);

util.factory('history', ['$rootScope', '$window', '$location', '$timeout', function($rootScope, $window, $location, $timeout) {
    var history = {};

    history.isBackRaw = function() {
        var historyState = $window.history.state;
        return  !!(historyState && historyState.position <= $rootScope.stackPosition);
    };

    history.setIsBack = function(back) {
        history.back = back;
    };

    history.isBack = function() {
        return history.back;
    };

    $rootScope.$watch(function() {
        var a = $('#content');
        if (a && a.length) {
            a = a[0];
            if (a.scrollHeight > a.clientHeight) {
                return a.scrollHeight;
            }
        }
    }, function(height) {
        if (height && history.isBack()) {
            var pos = $rootScope.scrollPos[$location.path()];
            var last = $rootScope.lastLocationChange || new Date();
            var now = new Date();
            var diff = now - last;
            if (pos && height > pos.y && height >= pos.height && diff < 2000) {
                delete $rootScope.scrollPos[$location.path()];
                $timeout(function() {
                    $('#content')[0].scrollTop = pos.y;
                });
            }
        }

    });

    return history;
}]);

util.filter('ellipsis', function() {
    return function(input, maxLength) {
        if (input.length > maxLength) {
            return input.slice(0, maxLength) + '...';
        }
        return input;
    };
});

util.directive('gsHtml', ['$compile', function($compile) {
    return {
        priority: 100,
        terminal: true,
        restrict: 'A',
        link: function ($scope, $element, $attr) {
            var childScope;
            $element[0].removeAttribute('gs-html');
            $scope.$watch($attr.gsHtml, function(template) {
                if(childScope) { childScope.$destroy(); }
                $element[0].innerHTML = template;
                childScope = $scope.$new();
                $compile($element)(childScope);
            });
        }
    };
}]);

util.run(['$rootScope', '$window', '$location', '$route', 'history', '$modalStack', function($rootScope, $window, $location, $route, history, $modalStack) {
    $rootScope.stackPosition = 0;
    $rootScope.scrollPos = {};

    // http://stackoverflow.com/questions/11541695/angular-js-redirecting-to-a-certain-route-based-on-condition
    // register listener to watch route changes
    $rootScope.$on("$routeChangeStart", function() {
        if ($rootScope.hasDoneInitialUserCheck) {
            if ($('.menu-button').is(':visible')) {
                $('#app').removeClass('on-canvas');
            }
        }

        var g = document.getElementById('globalpopover');
        if (g) {
            g.style.visibility = 'hidden';
        }
    });

    $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
        var scrollTop = $('#content')[0] ? $('#content')[0].scrollTop : 0;
        if (scrollTop) {
            var i = oldUrl.indexOf('#/') + 1;
            if (i) {
                oldUrl = oldUrl.substring(i);
                $rootScope.scrollPos[oldUrl] = {y: scrollTop, height: $('#content')[0].scrollHeight};
            }
        }

        $location.onlyForward = false;
    });

    $rootScope.$on('$locationChangeSuccess', function() {
        $rootScope.actualLocation = $location.path();
        $rootScope.lastLocationChange = new Date();
    });

    var prevLocation = null;
    $rootScope.$on('$locationChangeSuccess', function() {
        var newLocation = $location.path();
        if(newLocation == prevLocation) {return;}
        prevLocation = newLocation;

        //true only for onPopState
        if ($rootScope.actualLocation === newLocation) {
            if (history.isBackRaw()) {
                //back button
                $rootScope.stackPosition--;
                history.setIsBack(true);
                var top = $modalStack.getTop();
                if (top) {
                    $modalStack.dismiss(top.key);
                }
            } else {
                //forward button
                $rootScope.stackPosition++;
                history.setIsBack(false);
            }
        } else {
            //normal-way change of page (via link click)

            if ($route.current) {
                $window.history.replaceState({
                    position: $rootScope.stackPosition
                }, '');

                $rootScope.stackPosition++;
            }

            history.setIsBack(false);
        }
    });
}]);

util.controller('GetVariantCtrl', ['$scope', '$controller', 'util', 'formatter', 'options', function($scope, $controller, util, formatter, options) {
    $controller('AddCtrl', {$scope: $scope});

    var variants = angular.copy(options.product.variants) || [];
    var initial;
    variants.forEach(function(variant) {
        if (options.checkStock) {
            var stock = variant.stock;
            if (_.isNumber(stock)) {
                (options.basket || []).filter(function(i) { return i.variant == variant.name; }).forEach(function(i) {
                    stock -= i.count;
                });
                if (stock === 0) {
                    variant.title = variant.name + ' - ' + util.t('Sold out');
                    return;
                }
            }
        }

        variant.title = variant.name;
        if (!initial) {
            initial = variant;
        }
    });
    if (options.variant) {
        initial = _.findWhere(variants, {name: options.variant});
    }

    function getVariants() {
        return variants;
    }

    $scope.product = options.product;

    function outOfStock() {
        if (!options.checkStock) {
            return false;
        }

        var count = _.findWhere($scope.fields, {name: 'count'}).value;
        var variant = _.findWhere($scope.fields, {name: 'variant'}).value;
        if (variant) {
            if (_.isNumber(variant.stock)) {
                var stock = variant.stock;
                (options.basket || []).filter(function(i) { return i.variant == variant.name; }).forEach(function(i) {
                    stock -= i.count;
                });

                return stock < count;
            }
        } else if (_.isNumber(options.product.stock)) {
            return options.product.stock < count;
        }
    }

    $scope.getPrice = function(card, payWhatYouWantPrice) {
        var price = "";
        if (card.payWhatYouWant) {
            if (payWhatYouWantPrice) {
                price = formatter.format('price', payWhatYouWantPrice);
            } else {
                price = util.t('Optional');
            }
        } else if (card.price) {
            if (!card.priceType || card.priceType == 'OneTime') {
                price = formatter.format('price', card.price);
            } else {
                var priceType = util.t(card.priceType);
                price = formatter.format('price', card.price) + ' / ' + priceType;
            }
        } else {
            price = util.t('Free');
        }
        return price;
    };

    function possiblyUpdatePrice() {
        if (options.showPrice) {
            _.findWhere($scope.fields, {name: 'price'}).value = _.findWhere($scope.fields, {name: 'count'}).value * options.product.price;
        }
    }

    $scope.canSubmit = function() {
        return !outOfStock() && (!options.showPrice || Number(_.findWhere($scope.fields, {name: 'price'}).value) > 0);
    };

    $scope.submitTitle = options.submitTitle || 'Choose';
    $scope.showDescription = options.showDescription;

    var includedVariantFields = [];
    if (options.product.included_products && options.product.included_products.length) {
        options.product.included_products.forEach((productId) => {
            var product = _.findWhere($scope.$root.trainingcardtypes, {id: productId});
            if (product && product.needs_to_choose_variant && product.needs_to_choose_variant()) {
                var field = {
                    name: 'variants_for_included_products.' + product.id,
                    title: product.name,
                    required: true,
                    type: 'select',
                    options: () => product.variants,
                    getName: (v) => v.name,
                    getValue: (f) => f.value && f.value.name,
                    visible: () => true,
                    isIncludedProductVariant: true
                };
                if (product.variants.length === 1) {
                    field.value = product.variants[0];
                }
                includedVariantFields.push(field);
            }
        });
    }

    $scope.fields = [
        {name: 'variant', title: 'Product variant', required: true, type: 'select', options: getVariants, getValue: function(f) { return f.value && f.value.name; }, value: initial, getName: function(v) { return v.title; }, visible: function() { return options.product.needs_to_choose_variant(); } },
        ...includedVariantFields,
        {name: 'count', title: 'Count', required: true, type: 'number', value: 1, min: 1, visible: function() { return options.showCount; }, change: possiblyUpdatePrice },
        {name: 'price', title: 'Amount', required: true, type: 'price', min: 1, visible: function() { return options.showPrice; }, placeholder: 'Enter amount' },
        {name: 'barcode', title: 'Barcode', required: options.require_barcode, type: 'text', visible: function() { return options.showBarcode; } },
        {hint: 'Not enough products in stock', hintClass: 'alert-danger', visible: outOfStock},
    ];
    possiblyUpdatePrice();
}]);

util.directive('formRequiredField', ['$parse', function($parse) {
    return {
        link: function(scope, els, attrs) {
            var field = $parse(attrs.formRequiredField)(scope);

            var control = {
                $name: field.name,
                $error: {},
                $setPristine: angular.noop
            };
            control.$error[field.name] = false;

            scope.innerForm.$addControl(control);

            var requiredError = {
                $error: {
                    required: [{$name: field.name}]
                },
                $setPristine: angular.noop
            };

            scope.$on('$destroy', function () {
                if(scope.innerForm) { scope.innerForm.$removeControl(control); }
                if(scope.form) { scope.form.$setValidity('required', true, requiredError); }
            });

            scope.$watch(function() {return field.required && !field.value;}, function(error) {
                scope.form.$setValidity('required', !error, requiredError);
            });

        }
    };
}]);

util.controller('MultiButtonAnswerModalCtrl', ['$scope', 'options', function($scope, options) {
    $scope.options = options;
}]);

util.directive('workouttypeslistbanner', ['util', 'workoutProvider', function(util, workoutProvider) {
    return {
        restrict: 'E',
        templateUrl: 'views/workouttypeslistbanner.html',
        scope: {
            config: '='
        },
        link: function($scope) {

            $scope.workouts = [];
            $scope.loaded = false;

            var getCategoryId = function() {
                return $scope.config.context && $scope.config.context.id;
            };

            var hasWorkoutTypes = function() {
                return $scope.config.control ? $scope.config.control.getItems().length > 0 : false;
            };

            $scope.show = function() {
                if (!$scope.loaded) { return false; }
                var futureWorkouts = _.filter($scope.workouts, function(w) { return w.startTime.isFuture(); });
                return hasWorkoutTypes() && !futureWorkouts.length;
            };

            $scope.addWorkout = function() {
                util.showDataDialog({ controller: 'WorkoutDataCtrl', initial: {
                    date: Date.today(),
                    startTime: Date.newTime('18:00'),
                    endTime: Date.newTime('19:00'),
                    category_id: $scope.config.context,
                } });
            };

            var getWorkouts = function() {
                var start = new Date();
                var end = new Date().addMonths(6);
                workoutProvider.get(start.yyyymmdd(), end.yyyymmdd()).then(function(workouts) {
                    $scope.workouts = _.filter(workouts, function(w) {
                        return w.workoutType.category_id == getCategoryId() && w.startTime.isFuture();
                    });
                    $scope.loaded = true;
                });
            };
            getWorkouts();

            var removeWorkoutsChange = $scope.$on('workoutsChanged', getWorkouts);
            $scope.$on('$destroy', function () {
                removeWorkoutsChange();
            });
        }
    };
}]);

util.directive('modalguide', ['$rootScope', '$timeout', 'util', function($rootScope, $timeout, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/modalguide.html',
        link: function($scope, $element) {
            $element[0].style.position = 'absolute';
            $element[0].style.top = '1em';
            $element[0].style.right = '3em';

            $scope.active = false;
            $scope.driver = null;

            $scope.$parent.$finishGuide = function() {
                if (!$scope.active || !$scope.driver) { return; }
                $scope.driver.reset();
            };

            $scope.getStyle = function() {
                var s = { cursor: 'pointer' };
                if ($scope.active) {
                    s.color = 'green';
                }
                return s;
            };
            $scope.visible = function() {
                var guide = $scope.$getGuide();
                var steps = guide && guide.steps.filter(function(s) { return s.visible ? s.visible() : true; });
                return !$rootScope.isMobile() && (steps && steps.length);
            };

            $scope.getText = function() {
                return $scope.active ? 'Exit guide' : 'How do i';
            };

            var focusInput = function(e) {
                var input = e && e.node.querySelector('input');
                if (!input) { return;}
                input.focus();
            };

            var changeTab = function(name) {
                if (!name) { return; }
                if (!$scope.config || !$scope.config.control || !$scope.config.control.getTab) {
                    return;
                }
                var tab = $scope.config.control.getTab(name);
                if (!tab) { return; }
                $scope.config.control.setActiveTab(tab);
                $scope.$apply();
            };

            $scope.reload = function(index) {
                if ($scope.driver) {
                    $scope.driver.reset(true);
                }
                $scope.start({ data: { index: index || 0 } });
            };

            // https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
            var getScrollParent = function(node) {
                if (node == null) { return null; }
                if (node.scrollHeight > node.clientHeight) { return node; }
                else { return getScrollParent(node.parentNode); }
            };

            var scrollElement = null;
            var unbindScrollEvent = null;
            var scrollRefresh = function() {
                if ($scope.driver && $scope.driver.isActivated) {
                    var e = $scope.driver.getHighlightedElement();
                    if (e && e.getCalculatedPosition().bottom <= $('#content').height()) {
                        $scope.driver.overlay.refresh();
                    }
                } else {
                    unbindScrollEvent();
                }
            };
            unbindScrollEvent = function() {
                if (!scrollElement) { return; }
                angular.element(scrollElement).unbind('scroll', scrollRefresh);
                scrollElement = null;
            };

            var delayedStart = function(e) {
                $timeout(function() { $scope.start(e); }, 10);
            };
            $scope.start = function(e) {
                var guide = $scope.$getGuide();
                var steps = guide && guide.steps.filter(function(s) { return !!s.element && (s.visible ? s.visible() : true); });
                if (!steps || !steps.length) { return; }
                if (!$scope.driver) {
                    $scope.driver = new window.Driver({
                        opacity: 0,
                        animate: false,
                        allowClose: guide.allowClose == undefined ? true : guide.allowClose,
                        keyboardControl: false,
                        doneBtnText: util.t('Finish'),
                        closeBtnText: util.t('Close'),
                        nextBtnText: util.t('Next'),
                        prevBtnText: util.t('Previous'),
                        onHighlighted: focusInput,
                        onReset: function() {
                            angular.element('.driver-fix-stacking').each(function() { this.style.setProperty('z-index', $scope.initialZIndex || '1050', 'important'); });
                            var atEnd = $scope.currentStep == (steps.length-1);
                            if ($scope.active && (guide.onFinish && (guide.isFinished ? guide.isFinished() : atEnd))) {
                                guide.onFinish();
                            }
                        }
                    });
                }

                if (scrollElement) {
                    unbindScrollEvent();
                }

                scrollElement = getScrollParent($element[0].parentElement);
                if (scrollElement) {
                    angular.element(scrollElement).bind('scroll', scrollRefresh);
                }

                var fixBackdrop = function() {
                    var zIndex = $element[0].closest('div[modal-window]').style.zIndex;
                    if (zIndex < 9000) { $scope.initialZIndex = zIndex; }

                    angular.element('.driver-fix-stacking').each(function() { this.style.setProperty('z-index', '9999', 'important'); });
                    angular.element('.driver-stage-no-animation')[0].style.setProperty('z-index', '9998', 'important');
                };

                angular.forEach(steps, function(item, index) {
                    if (!item.skipStartOnClick) {
                        var elem = angular.element(item.element);
                        if (elem[0]) {
                            elem[0].style.cursor = 'pointer';
                        }
                        elem.off('click', delayedStart);
                        elem.on('click', { index: index }, delayedStart);
                    }

                    item.popover.title = item.popover.title ? util.t(item.popover.title) : ' ';
                    item.popover.description = item.popover.description ? util.t(item.popover.description) : '';
                    item.popover.position = item.popover.position || 'left';
                    if (item.popover.closeBtnText) {
                        item.popover.closeBtnText = util.t(item.popover.closeBtnText);
                    }

                    item.onNext = function() {
                        var next = steps[index+1];
                        if (!next) { return; }
                        $scope.driver.preventMove();
                        changeTab(next.tab);
                        $timeout(function() {
                            if ($(next.element).is(':visible')) {
                                $scope.driver.moveNext();
                            } else {
                                $scope.reload(index+1);
                            }
                        });
                    };
                    item.onPrevious = function() {
                        var previous = steps[index-1];
                        if (!previous) { return; }
                        $scope.driver.preventMove();
                        changeTab(previous.tab);
                        $timeout(function() {
                            if ($(previous.element).is(':visible')) {
                                $scope.driver.movePrevious();
                            } else {
                                $scope.reload(index-1);
                            }
                        });
                    };
                    item.onHighlightStarted = function() {
                        $scope.currentStep = index;
                    };
                });

                $timeout(function() {
                    $scope.driver.defineSteps(steps);
                    var start = 0;
                    if (e && e.data.index) {
                        start = e.data.index;
                    }
                    $scope.driver.start(start);
                    $scope.currentStep = start;
                    fixBackdrop();
                });
            };
            $scope.stop = function() {
                if (!$scope.driver) { return; }
                var guide = $scope.$getGuide();
                angular.forEach(guide.steps, function(step) {
                    var elem = angular.element(step.element);
                    if (!elem[0]) { return; }
                    elem[0].style.cursor = '';
                    elem.off('click', delayedStart);
                });
                $scope.currentStep = 0;
                $scope.driver.reset(true);
            };

            $scope.toggleActive = function() {
                $scope.active = !$scope.active;
                if ($scope.active) {
                    $scope.start();
                } else {
                    $scope.stop();
                }
            };

            var startImmediately = function() {
                var cancelwatch = $scope.$watch('$getGuide()', function(guide) {
                    if (!guide) { return; }
                    cancelwatch();
                    $scope.toggleActive();
                });
            };

            $timeout(function() {
                $rootScope.pubsub('startGuide', function(start) {
                    $rootScope.pubsub.unsubscribe();
                    if (!start) { return; }
                    startImmediately();
                    $rootScope.pubsub.publish('startGuide', false);
                }, true);
            }, 1000);

            $scope.$on('$destroy', function () {
                $rootScope.pubsub.unsubscribe();
                unbindScrollEvent();
            });
        }
    };
}]);

util.directive('panelguide', ['$rootScope', '$q', '$timeout', 'util', function($rootScope, $q, $timeout, util) {
    return {
        restrict: 'E',
        scope: {
            config: '=?',
            tabsetdata: '=?'
        },
        templateUrl: 'views/panelguide.html',
        link: function($scope, $element) {

            $element[0].style.position = 'absolute';
            $element[0].style.width = '100%';

            $scope.active = false;
            $scope.current = null;
            $scope.driver = null;
            $scope.guides = [];

            $scope.$parent.$registerGuide = function(guide) {
                if (_.findWhere($scope.guides, { id: guide.id })) { return; }
                $scope.guides.push(guide);
                if ($scope.guides.length == 1) {
                    $scope.startWait();
                }
            };

            $scope.$parent.$getGuide = function(id) {
                return _.findWhere($scope.guides, { id: id });
            };

            $scope.$parent.$startGuide = function(id) {
                var guide = _.findWhere($scope.guides, { id: id });
                if (!guide) { return; }
                $scope.setCurrent(guide);
                return $scope.start();
            };

            $scope.single = function() {
                return $scope.guides.filter(function(g) { return !g.hidden; }).length == 1;
            };

            $scope.getStyle = function() {
                return {
                    cursor: 'pointer',
                    color: $scope.active ? 'green' : 'gray',
                };
            };

            $scope.visible = function() {
                return !$rootScope.isMobile() && $scope.guides.length;
            };

            $scope.setCurrent = function(guide) {
                $scope.current = guide;
            };

            var focusInput = function(e) {
                if (!e) { return; }
                var input = e.node.tagName == 'INPUT' ? e.node : e.node.querySelector('input');
                if (!input) { return;}
                input.focus();
            };

            var changeTab = function(name) {
                if (!name) { return false; }

                if ($scope.tabsetdata) {
                    if ($scope.tabsetdata[name]) { return false; }
                    angular.forEach(Object.keys($scope.tabsetdata), function(key) {
                        $scope.tabsetdata[key] = (key == name);
                    });
                    $scope.tabsetdata[name] = true;
                }
                else if ($scope.config && $scope.config.control && $scope.config.control.getTab) {
                    var tab = $scope.config.control.getTab(name);
                    if (!tab || $scope.config.control.getActiveTab() == tab) {
                        return false;
                    }
                    $scope.config.control.setActiveTab(tab);
                }
                else { return false; }
                $timeout(function() { $scope.$apply(); });
                return true;
            };


            // https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
            var getScrollParent = function(node) {
                if (node == null) { return null; }
                if (node.scrollHeight > node.clientHeight) { return node; }
                else { return getScrollParent(node.parentNode); }
            };

            var scrollElement = null;
            var unbindScrollEvent = null;
            var scrollRefresh = function() {
                if ($scope.driver) {
                    $scope.driver.overlay.refresh();
                } else {
                    unbindScrollEvent();
                }
            };
            unbindScrollEvent = function() {
                if (!scrollElement) { return; }
                angular.element(scrollElement).unbind('scroll', scrollRefresh);
                scrollElement = null;
            };

            $scope.start = function(e, retry) {
                var deferred = $q.defer();
                retry = retry || 1;
                if (retry > 4) {
                    deferred.reject();
                    return deferred.promise;
                }

                if (changeTab($scope.current.tab)) {
                    $timeout(function() { $scope.start(e, retry).then(deferred.resolve, deferred.reject); }, 250);
                    return deferred.promise;
                }

                if ($scope.current.redirect) {
                    $scope.active = false;
                    $scope.current.redirect();
                    deferred.resolve();
                    return deferred.promise;
                }

                var steps = $scope.current.steps();
                if (!steps) {
                    deferred.reject();
                    return deferred.promise;
                }

                var doRetry = function() {
                    $timeout(function() {
                        $scope.start(e, retry+1).then(deferred.resolve, deferred.reject);
                    }, 500 * retry);
                    return deferred.promise;
                };

                steps = steps.filter(function(s) { return s.element; });
                if (!steps.length) {
                    return doRetry();
                }

                if (!$scope.driver) {
                    $scope.driver = new window.Driver({
                        opacity: 0,
                        animate: false,
                        doneBtnText: util.t('Finish'),
                        closeBtnText: util.t('Close'),
                        nextBtnText: util.t('Next'),
                        prevBtnText: util.t('Previous'),
                        onHighlighted: focusInput,
                        onReset: function() {
                            if (!$scope.current) {
                                deferred.resolve();
                                return;
                            }
                            var steps = $scope.current.steps();
                            var atEnd = $scope.currentStep == (steps.length-1);
                            if (atEnd) {
                                deferred.resolve();
                            }
                            if ($scope.current.onFinish && ($scope.current.isFinished ? $scope.current.isFinished() : atEnd)) {
                                $scope.current.onFinish();
                            } else if (!atEnd) {
                                $rootScope.askIfShouldExitGuide($scope.driver, $scope.currentStep);
                            }
                        }
                    });
                }

                if (scrollElement) {
                    unbindScrollEvent();
                }

                scrollElement = getScrollParent($element[0].parentElement);
                if (scrollElement) {
                    angular.element(scrollElement).bind('scroll', scrollRefresh);
                }

                var retrying = false;
                angular.forEach(steps, function(item, index) {
                    if (retrying) { return; }
                    var item = steps[index];
                    if (!item.skipStartOnClick && !item.closeOnClick) {
                        var elem = angular.element(item.element);
                        if (!elem[0]) {
                            retrying = true;
                            return;
                        }
                        elem[0].style.cursor = 'pointer';
                        elem.off('click', $scope.start);
                        elem.on('click', { index: index }, $scope.start);
                    }

                    item.popover.title = item.popover.title ? util.t(item.popover.title) : ' ';
                    item.popover.description = item.popover.description ? util.t(item.popover.description) : '';
                    if (item.popover.doneBtnText) {
                        item.popover.doneBtnText = util.t(item.popover.doneBtnText);
                    }
                    if (item.popover.closeBtnText) {
                        item.popover.closeBtnText = util.t(item.popover.closeBtnText);
                    }

                    item.onNext = function() {
                        var next = steps[index+1];
                        if (!next) {
                            deferred.resolve();
                            return;
                        }
                        $scope.driver.preventMove();
                        changeTab(next.tab);
                        $timeout($scope.driver.moveNext, 10);
                    };
                    item.onPrevious = function() {
                        var previous = steps[index-1];
                        if (!previous) { return; }
                        $scope.driver.preventMove();
                        changeTab(previous.tab);
                        $timeout($scope.driver.movePrevious, 10);
                    };

                    item.onHighlightStarted = function(e) {
                        $scope.currentStep = index;
                        if (item.closeOnClick) {
                            e.node.addEventListener('click', function() {
                                $scope.driver.reset();
                            });
                        }
                    };
                });
                if (retrying) {
                    return doRetry();
                }

                var start = 0;
                if (e && e.data.index) {
                    start = e.data.index;
                }
                if (steps[start].tab) { changeTab(steps[start].tab); }

                $timeout(function() {
                    try {
                        angular.element(steps[start].element)[0].scrollIntoView({ block: 'center' });
                        $scope.driver.defineSteps(steps);
                        $scope.driver.start(start);
                        $scope.active = true;
                        $scope.currentStep = start;
                    } catch (e) {
                        doRetry().then(deferred.resolve, deferred.reject);
                    }
                });

                return deferred.promise;
            };

            $scope.stop = function() {
                if (!$scope.driver) { return; }
                var steps = $scope.current.steps();
                angular.forEach(steps, function(item) {
                    var elem = angular.element(item.element);
                    if (!elem[0]) { return; }
                    elem[0].style.cursor = '';
                    elem.off('click', $scope.start);
                });
                $scope.current = null;
                $scope.currentStep = 0;
            };

            $scope.toggleActive = function() {
                $scope.active = !$scope.active;
                if ($scope.active && $scope.single()) {
                    $scope.setCurrent(_.find($scope.guides, function(guide) { return !guide.hidden; }));
                    $scope.start();
                } else if (!$scope.active) {
                    $scope.stop();
                }
            };


            $scope.startWait = function() {
                $timeout(function() {
                    $scope.pubsub('startGuide', function(id) {
                        var guide = _.findWhere($scope.guides, { id: id });
                        if (!guide) { return; }
                        $scope.setCurrent(guide);
                        $scope.start();
                        $scope.pubsub.publish('startGuide', false);
                    }, true);
                });
            };

            $scope.$on('$destroy', function() {
                unbindScrollEvent();
            });
        }
    };
}]);


// Sentry config
if (!window.__devenv && location.hostname != 'zoezidev.se') {
    Raven.config('https://ed2d0705465c4b17a2837304ee76cd40@sentry.io/1290351', {tags: {'hostname': location.hostname, 'Frontend': true}}).install();
} else {
    // Provide an empty module to avoid injection error
    angular.module('ngRaven', []);
}
